import { Convert, ConvertDateToUnixOrNull, DefaultArrayEmpty, FnAxios, FnDialog, formatNumber, I18n, ParseHtml, RouterDOM } from "utilities/utilities";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { ActivityInterface, BoardMeetingInterface, DurationInterface } from "./interfaceActionFund";
import moment from "moment";
import { parseFloatCheckValue } from "view/Backend/IncomeExpenses/Ticket/fnTickit";
import { BtnEditOnTable, BtnViewOnTable } from "components/Button/ButtonTable";
import { useNavigate } from "react-router";
import { PaginationInterface, initRows } from "components/DataGrid";
import { Info } from "@mui/icons-material";
import { Grid, IconButton } from "@mui/material";
import _ from "lodash";
import { GetMenuPermission } from "utilities/SystemFunction";

export const useFundActionPlanGrid = () => {
    const navigate = useNavigate();
    const [sUpdateName, setUpdateName] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [isPermission, setIsPermission] = useState<boolean>(false);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleViewInfo = (e) => {
        setUpdateName(e.sUpdate);
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    useEffect(() => {
        GetMenuPermission(AxiosFn, setIsPermission, DialogFn);
    }, []);
    
    const dataColumn = [
        {
            headerName: "ดำเนินการ",
            field: "",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 100,
            getActions: (item) => {

                return [
                    <>
                        {isPermission ?
                            <BtnEditOnTable
                                key={item.row.sID}
                                id="btnEdit"
                                onClick={() => handleEdit(item.row.sID)}
                            />
                            :
                            <BtnViewOnTable
                                key={item.row.sID}
                                id="btnEdit"
                                onClick={() => handleEdit(item.row.sID)}
                            />
                        }
                    </>
                ];
            },
        },
        {
            field: "sAction",
            headerName: "สถานะ",
            headerAlign: "center",
            editable: false,
            resizable: false,
            align: "center",
            sortable: false,
            width: 120,
        },
        {
            field: "sYear",
            headerName: "ประจำปีบัญชี",
            headerAlign: "center",
            align: "center",
            resizable: false,
            sortable: true,
            flex: 2,
            minWidth: 160,
        },
        {
            field: "sLastUpdate",
            headerName: "วันที่แก้ไขล่าสุด",
            headerAlign: "center",
            editable: false,
            resizable: false,
            align: "center",
            sortable: true,
            width: 200,
            renderCell: (item) => {
                return (
                    <>
                        <Grid sx={{ mr: "4px" }}>
                            {item.row.sLastUpdate}
                        </Grid>
                        <IconButton size="small"
                            onClick={(e) => { handleClick(e); handleViewInfo(item.row); }}
                        >
                            <Info
                                style={{ color: "#6e130d", cursor: "pointer" }}
                            />
                        </IconButton>
                    </>
                )
            }
        },
    ];

    const handleEdit = (sID: string) => {
        navigate(`/FundActionPlanForm?sFundWorkID=${sID}`);
    };

    return { dataColumn, open, anchorEl, handleClose, sUpdateName, isPermission };
};

export const useFundActionPlanTable = () => {
    const navigate = useNavigate();

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [isLoading, setIsLoading] = useState(false);

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "sLastUpdate",
        sSortDirection: "desc"
    });

    const onGetData = (p) => {
        setIsLoading(true);
        let dStart = moment(form.getValues("sUpdateDateStart"));
        let dEnd = moment(form.getValues("sUpdateDateEnd"));

        let param = {
            sSortDirection: p.sSortDirection,
            sSortExpression: p.sSortExpression,
            nPageIndex: p.nPageIndex,
            nPageSize: p.nPageSize,
            nYear: form.getValues("sYear"),
            nDateStart: dStart.isValid() ? ConvertDateToUnixOrNull(dStart) : null,
            nDateEnd: dEnd.isValid() ? ConvertDateToUnixOrNull(dEnd) : null,
        }
        AxiosFn.Get(`FundActionPlan/GetFundActionPlan`, param, (result) => {
            let data = result.objResult.result;
            setIsLoading(false);
            if (data) {
                setDataRow({
                    ...p,
                    arrRows: [...data.lstData],
                    nDataLength: data.nDataLength
                })
            } else {
                setDataRow({
                    ...p,
                    arrRows: [],
                    nDataLength: 0
                })
            }
        })
    }

    const onClear = () => {
        form.setValue("sUpdateDateStart", null);
        form.setValue("sUpdateDateEnd", null);
        form.setValue("sYear", null);
        onGetData(dataRow);
    }

    const onDelete = (lstID) => {
        let param = {
            lstID: lstID
        }
        DialogFn.Submit("คุณการลบข้อมูลใช่หรือไม่?", () => {
            DialogFn.BlockUI();
            AxiosFn.Post(`FundActionPlan/OnDeleteFundActionPlan`, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.sMessage) {
                    DialogFn.Warning(result.sMessage);
                } else {
                    DialogFn.Success(`บันทึกสำเร็จ`);
                    DialogFn.CloseSubmit();
                    onGetData(dataRow);
                }

            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    }

    const onAddForm = () => {
        navigate(`/FundActionPlanForm`);
    }

    const onBack = () => {
        navigate(`/FundActionPlan`);
    }

    useEffect(() => {
        onGetData(dataRow);
    }, []);

    return { form, dataRow, onGetData, onClear, onAddForm, onDelete, isLoading, onBack };
};

export function useFundActionPlanGanttChart() {

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });

    const [tasks, setTasks] = useState([]);
    const [arrYear, setArrYear] = useState([]);
    const [arrActivity, setArrActivity] = useState([]);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        GetOptionYear();
    }, []);

    const handleChangeYear = (nYear) => {
        if (nYear) {
            AxiosFn.Get(`FundActionPlan/GetFundGanttChart`, { nYear: nYear.value }, (result) => {
                DialogFn.UnBlockUI();
                if (result.sMessage) {
                    DialogFn.Warning(result.sMessage);
                    setTasks([]);
                } else if (result.objResult) {
                    let lstGanttChart = [...result.objResult.lstGanttChart];
                    lstGanttChart.forEach(f => {
                        f.start = new Date(f.start);
                        f.end = new Date(f.end);
                    });
                    setTasks(lstGanttChart);
                } else {
                    setTasks([]);
                }
            });
        } else {
            setTasks([]);
        }
    }

    const GetOptionYear = () => {
        AxiosFn.Get(`FundActionPlan/GetFilterFundActionPlan`, { IsSubmitted: true }, (result) => {
            let lstYear = [...result.objResult.lstYear];
            setArrYear([...lstYear]);
            lstYear = lstYear.sort((a, b) => a.value - b.value);
            let nCurrentYear = lstYear.find(f => f.value >= moment().year());
            if (nCurrentYear) {
                form.setValue("nYear", nCurrentYear.value);
                handleChangeYear(nCurrentYear);
            }
        });
    }

    const handleExpanderClick = (task) => {
        setTasks(tasks.map((t) => (t.id === task.id ? task : t)));
    };

    const handleOpen = (value) => {
        setOpen(value);
    };

    const handleClose = () => {
        handleOpen(false);
    }

    return { form, tasks, arrYear, open, handleClose, handleOpen, handleExpanderClick, handleChangeYear, arrActivity, setArrActivity };
}
export function useFundActionPlan() {
    const form = useForm({
        // shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });

    const formGoal = useForm({
        // shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });

    const formTarget = useForm({
        // shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });

    const formStrategy = useForm({
        // shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });

    const formProject = useForm({
        // shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });

    const formBoardMeeting = useForm({
        // shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });

    const formBoardMeetingTable = useForm({
        // shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });

    const formStrategic = useForm({
        // shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });

    const formDuration = useForm({
        // shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });

    const formAssign = useForm({
        // shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });

    const formActivity = useForm({
        // shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sAssignPerson: null
        } as any,
    });

    const defaultDuration = [{ nID: 1, sID: "1" }] as any;
    const defaultBoardMeeting = [{ nID: 1, sID: "1" }] as any;
    const defaultActivity = [{ nID: 1, sID: "1" }] as any;

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const Router = RouterDOM();

    const [loadingTable, setLoadingTable] = useState(false);
    const [arrOptionOrderGoal, setArrOptionOrderGoal] = useState([]);
    const [arrOptionOrderStrategic, setArrOptionOrderStrategic] = useState([]);
    const [arrOptionStrategic, setArrOptionStrategic] = useState([]);
    const [arrOptionStrategy, setArrOptionStrategy] = useState([]);
    const [arrOptionOrderTarget, setArrOptionOrderTarget] = useState([]);
    const [arrOptionOrderStrategy, setArrOptionOrderStrategy] = useState([]);
    const [arrOptionTarget, setArrOptionTarget] = useState([]);
    const [arrOptionOrderProject, setArrOptionOrderProject] = useState([]);
    const [arrOptionProject, setArrOptionProject] = useState([]);
    const [trigger, setTrigger] = useState(0);
    const [nMaxActivity, setNMaxActivity] = useState(0);
    const [nProjectCurrent, setNProjectCurrent] = useState(null);
    const [nTriggerDuration, setNTriggerDuration] = useState(0);

    const [arrDuration, setArrDuration] = useState<DurationInterface[]>(defaultDuration as DurationInterface[]);
    const [arrBoardMeeting, setArrBoardMeeting] = useState<BoardMeetingInterface[]>(defaultBoardMeeting as BoardMeetingInterface[]);
    const [arrActivity, setArrActivity] = useState<ActivityInterface[]>(defaultActivity as ActivityInterface[]);

    const [dataRowGoal, setDataRowGoal] = useState([]);
    const [dataRowStrategic, setDataRowStrategic] = useState([]);
    const [dataRowTarget, setDataRowTarget] = useState([]);
    const [dataRowStrategy, setDataRowStrategy] = useState([]);
    const [dataRowProject, setDataRowProject] = useState([]);
    const [dataRowAssign, setDataRowAssign] = useState([]);
    const [dataRowCommittee, setDataRowCommittee] = useState([]);
    const [dataRowActivity, setDataRowActivity] = useState([]);
    const [dataOptionActivity, setDataOptionActivity] = useState([]);

    const [isSubActivity, setIsSubActivity] = useState(false);
    const [isBoardMeeting, setIsBoardMeeting] = useState(false);
    const [nYear, setNYear] = useState(moment().year());


    const [nMaxMonth, setNMaxMonth] = useState(null);
    const [nMinMonth, setNMinMonth] = useState(null);
    const [nMaxBudget, setNMaxBudget] = useState(null);
    const [nMaxWeight, setNMaxWeight] = useState(null);
    const [nParentID, setNParentID] = useState(null);

    const [nMaxMonthDueDate, setNMaxMonthDueDate] = useState(null);
    const [nMinMonthDueDate, setNMinMonthDueDate] = useState(null);

    const [nEditGoal, setNEditGoal] = useState(null);
    const [nEditStrategic, setNEditStrategic] = useState(null);
    const [nEditTarget, setNEditTarget] = useState(null);
    const [nEditStrategy, setNEditStrategy] = useState(null);
    const [nEditProject, setNEditProject] = useState(null);
    const [nEditActivity, setNEditActivity] = useState(null);
    const [nEditActivityProject, setNEditActivityProject] = useState(null);
    const [nEditCommittee, setNEditCommittee] = useState(null);
    const [nEditAssign, setNEditAssign] = useState(null);

    //initail
    const [arrOptionIndicator, setArrOptionIndicator] = useState([]);
    const [arrOptionCommittee, setArrOptionCommittee] = useState([]);
    const [nFundWorkID, setNFundWorkID] = useState(null);
    const [objDataForm, setObjDataForm] = useState({} as any);
    const [isSubmitted, setisSubmitted] = useState(false);
    const [isDuplicate, setIsDuplicate] = useState(false);

    //file
    const handleClearAttachFileMOU = useRef(null);
    const handleClearAttachFilePlan = useRef(null);
    const [arrFileMOU, setArrFileMOU] = useState([]);
    const [arrFilePlan, setArrFilePlan] = useState([]);

    const lstMonth = [
        {
            nMonth: 1,
            IsChecked: false
        },
        {
            nMonth: 2,
            IsChecked: false
        },
        {
            nMonth: 3,
            IsChecked: false
        },
        {
            nMonth: 4,
            IsChecked: false
        },
        {
            nMonth: 5,
            IsChecked: false
        },
        {
            nMonth: 6,
            IsChecked: false
        },
        {
            nMonth: 7,
            IsChecked: false
        },
        {
            nMonth: 8,
            IsChecked: false
        },
        {
            nMonth: 9,
            IsChecked: false
        },
        {
            nMonth: 10,
            IsChecked: false
        },
        {
            nMonth: 11,
            IsChecked: false
        },
        {
            nMonth: 12,
            IsChecked: false
        }
    ];

    const onDuplicateForm = () => {
        let dDate = moment(nYear + "/01/01");
        if (!dDate.isValid()) {
            dDate = moment();
        }
        dDate = dDate.add(1, 'year');
        form.setValue("sFiscalYear", dDate);
        setNYear(dDate.year());
        handleChangeFiscalYear(dDate, null);

        setIsDuplicate(true);
        setNFundWorkID(null);
    }

    const [isPermission, setIsPermission] = useState<boolean>(false);

    useEffect(() => {
        GetMenuPermission(AxiosFn, setIsPermission, DialogFn);
    }, []);

    useEffect(() => {
        if (isDuplicate) {
            handleSubmitPlan();
        }
    }, [isDuplicate])

    const handleEditGoal = (nID) => {
        let clone = [...dataRowGoal];
        let obj = clone.find(f => f.nID === nID);

        if (obj) {
            formGoal.setValue("sGoalName", obj.sGoalName);
            setNEditGoal(nID);
        }
    }

    const handleEditStrategic = (nID) => {
        let clone = [...dataRowStrategic];
        let obj = clone.find(f => f.nID === nID);

        if (obj) {
            formStrategic.setValue("sStrategicName", obj.sStrategicName);
            setNEditStrategic(nID);
        }
    }

    const handleEditStrategy = (nID) => {
        let clone = [...dataRowStrategy];
        let ClonChildren = [].concat(...clone.map(m => m.lstChildren));
        let obj = ClonChildren.find(f => f.nID === nID);

        if (obj) {
            formStrategy.setValue("sStrategyStrategic", obj.nStrategicID);
            formStrategy.setValue("sStrategyName", obj.sStrategyName);
            setNEditStrategy(nID);
        }
    }

    const handleEditTarget = (nID) => {
        let clone = [...dataRowTarget];
        let ClonChildren = [].concat(...clone.map(m => m.lstChildren));
        let obj = ClonChildren.find(f => f.nID === nID);

        if (obj) {
            formTarget.setValue("sTargetStrategic", obj.nStrategicID);
            formTarget.setValue("sTargetStrategicName", obj.sTargetName);
            setNEditTarget(nID);
        }
    }

    const handleEditProject = (nID) => {
        let clone = [...dataRowProject];
        let ClonChildren = [].concat(...clone.map(m => m.lstChildren));
        let obj = ClonChildren.find(f => f.nID === nID);
        let cloneIndicator = [...arrOptionIndicator];
        let lstProjectIndicator = cloneIndicator.filter(f => obj.lstProjectIndicator.includes(f.value)).map(m => m.value);
        let lstChildren = [].concat(...cloneIndicator.map(m => m.children)).filter(f => obj.lstProjectIndicator.includes(f.value)).map(m => m.value).concat([...lstProjectIndicator]);
        let objIndicator = Object.assign({}, ...[...lstChildren].map(key => ({ [key]: true })));

        cloneIndicator.forEach(m => {
            if (lstChildren.includes(m.value)) {
                m.icon = "pi pi-fw pi-check-square";
                //set selectable
                m.children.forEach(m => { m.selectable = false; m.className = "disabled-text" });
            }
            [...m.children].forEach(f => {
                if (lstChildren.includes(f.value)) {
                    f.icon = "pi pi-fw pi-check-square";
                    //set selectable
                    m.selectable = false;
                    m.className = "disabled-text";
                }
            })

        });

        setArrOptionIndicator([...cloneIndicator]);

        if (obj) {
            formProject.setValue("sProjectStrategy", obj.nStrategyID);
            formProject.setValue("sProjectName", obj.sProjectName);
            formProject.setValue("sTargetUnit", obj.sTargetUnit);
            formProject.setValue("sIndicatorRef", objIndicator);
            formProject.setValue("sOutputQuantitative", obj.sOutputQuantitative);
            formProject.setValue("sOutputQualitative", obj.sOutputQualitative);
            formProject.setValue("sOutcomeQuantitative", obj.sOutcomeQuantitative);
            formProject.setValue("sOutcomeQualitative", obj.sOutcomeQualitative);
            formProject.setValue("sImpact", obj.sImpact);
            setNEditProject(nID);
        }
    }

    const onSetSubActivity = (nID, nParentID, lstActivity, arr = arrActivity) => {
        formActivity.setValue(`sUnderActivity_${nID}`, nParentID);
        let objActivity = [...lstActivity].find(f => f.nID === nParentID);
        if (objActivity.isSubActivity) {
            let arrNew = [{ nID: objActivity.nID, sID: objActivity.nID + "" }, ...arr]
            setArrActivity(arrNew);
            onSetSubActivity(objActivity.nID, objActivity.nParentID, lstActivity, arrNew);
        }
    }

    const handleEditActivity = (nID, nProjectID) => {
        let clone = [...dataRowActivity];
        let arrClone = clone.filter(x => x.lstStrategy.some(c => c.lstProject.some(r => r.nID === nProjectID)));

        setNProjectCurrent(nProjectID);

        arrClone.forEach(item => {
            [...item.lstStrategy].forEach(strategy => {
                [...strategy.lstProject].forEach(project => {
                    if (project.nProjectID === nProjectID) {
                        let objActivity = [...project.lstActivity].find(f => f.nID === nID);

                        if (objActivity) {
                            let nBudget = parseFloat((objActivity.sBudget + "").replace(/,/g, ''));

                            formActivity.setValue("sActivityProject", objActivity.nProjectID);
                            formActivity.setValue("sActivityName", objActivity.sActivityName);
                            formActivity.setValue("isSubActivity", objActivity.isSubActivity);
                            setIsSubActivity(objActivity.isSubActivity);
                            setIsBoardMeeting(objActivity.isCommitteeMeeting);
                            formActivity.setValue("isBoardMeeting", objActivity.isCommitteeMeeting);

                            if (objActivity.isSubActivity) {
                                let arrAc = [{ nID: objActivity.nID, sID: objActivity.nID + "" }]
                                setArrActivity(arrAc);
                                onSetSubActivity(objActivity.nID, objActivity.nParentID, project.lstActivity, arrAc);
                                setNParentID(objActivity.nParentID);
                            }
                            formActivity.setValue("sBudget", isNaN(nBudget) ? null : nBudget);
                            setDataRowAssign(objActivity.lstAssign);
                            setDataRowCommittee(objActivity.lstMeeting);

                            let lstDuration = [...objActivity.lstDuration];
                            let arrDuration = [];
                            if (lstDuration.length === 0) {
                                arrDuration.push({ nID: 1, sID: "1" });
                            }
                            lstDuration.forEach(f => {
                                let arrForm = { nID: f.nID, sID: f.nID + "" };
                                let nWeight = parseFloat(f.sWeight);
                                arrDuration.push(arrForm);

                                formDuration.setValue(`sStartMonth_${f.nID}`, moment(f.nUnixTimeStart));
                                formDuration.setValue(`sEndMonth_${f.nID}`, moment(f.nUnixTimeEnd));
                                formDuration.setValue(`sWeight_${f.nID}`, isNaN(nWeight) ? null : nWeight);
                            });

                            let arrCurrent = [...dataOptionActivity].filter(f => f.value === nID && f.nProjectID === nProjectID);

                            //set array parent 
                            setDataOptionActivity([...dataOptionActivity].filter(f => !arrCurrent.find(rm => (rm.value === f.value && f.nProjectID === rm.nProjectID))));

                            setArrDuration(arrDuration);
                            setNEditActivity(nID);
                            setNEditActivityProject(nProjectID);
                        }

                    }
                })
            })
        });
    }

    const handleChangeProject = () => {
        setNProjectCurrent(formActivity.getValues("sActivityProject"));
    }

    const handleChangeSubActivity = (event) => {
        setIsSubActivity(event);

        if (!event) {
            setArrActivity(defaultActivity);
        }
    }

    const handleChangeBoardMeeting = (event) => {
        setIsBoardMeeting(event);

        if (!event) {
            setArrBoardMeeting(defaultBoardMeeting);
            setDataRowCommittee([]);
        }
    }

    const onAddGoal = () => {
        let lstData = [...dataRowGoal];
        let result = [...lstData];
        if (nEditGoal) {
            let obj = lstData.find(f => f.nID === nEditGoal);

            if (obj) {
                obj.sGoalName = formGoal.getValues("sGoalName");
                obj.sName = obj.sGoalName;
                result = [...lstData.filter(f => f.nID !== nEditGoal), obj];
            }

        } else {
            let nMax = lstData.length > 0 ? Math.max(...lstData.map(o => o.nID)) : 0;
            let nNo = lstData.length > 0 ? Math.max(...lstData.map(o => o.nOrder)) : 0;

            nMax = nMax + 1;
            let obj = {
                nID: nMax,
                sID: nMax + "",
                nGoalID: nMax,
                isNew: true,
                nOrder: (isNaN(nNo) ? 0 : nNo) + 1,
                sGoalName: formGoal.getValues("sGoalName"),
                sName: formGoal.getValues("sGoalName")
            }

            setArrOptionOrderGoal([...arrOptionOrderGoal, { value: obj.nOrder + "", label: obj.nOrder }]);

            result = [...lstData, obj];
        }
        result = result.sort((a, b) => a.nOrder - b.nOrder);
        setDataRowGoal(result);

        formGoal.setValue("sGoalName", null);
        setNEditGoal(null);
    }

    const handleSubmitTarget = () => {
        let lstData = [...dataRowTarget];
        let nStrategicID = formTarget.getValues("sTargetStrategic");
        let sStrategic = arrOptionStrategic.find(f => f.value === nStrategicID);
        let lstChildren = [];

        if (sStrategic) {

            let old = lstData.find(f => f.nID === nStrategicID);

            if (!old) {
                old = {
                    nID: nStrategicID,
                    sID: nStrategicID + "",
                    nOrder: sStrategic.nOrder,
                    nStrategicID: nStrategicID,
                    sName: sStrategic.label,
                    sTopic: sStrategic.sTopic,
                    sNoTopic: sStrategic.sNoTopic,
                    IsHead: true,
                    lstChildren: []
                }
            }

            let ClonChildren = [].concat(...lstData.map(m => m.lstChildren));
            let ClonOrder = old.lstChildren;

            let obj = ClonChildren.find(f => f.nID === nEditTarget);
            if (obj) {
                if (obj.nStrategicID !== nStrategicID) {
                    let oldStrategic = lstData.find(f => f.nID === obj.nStrategicID);
                    if (oldStrategic) {
                        oldStrategic.lstChildren = [...oldStrategic.lstChildren].filter(f => f.nID !== obj.nID);
                        let nOrder = 1;
                        oldStrategic.lstChildren.forEach(f => {
                            f.nOrder = nOrder++;
                        })
                        let lstActivty = [...dataRowActivity];
                        let objActivity = lstActivty.find(f => f.nStrategicID === obj.nStrategicID);
                        if (objActivity) {
                            objActivity.lstTarget = oldStrategic.lstChildren;
                        }

                    }
                    obj.nOrder = ClonOrder.length + 1;
                } else {
                    ClonOrder = ClonOrder.filter(f => f.nID !== obj.nID)
                }

                obj.nStrategicID = nStrategicID;
                obj.sTargetName = formTarget.getValues("sTargetStrategicName");
                obj.sName = formTarget.getValues("sTargetStrategicName");

            } else {
                let nMaxC = ClonChildren.length > 0 ? Math.max(...ClonChildren.map(o => o.nID)) : 0;

                let nNoC = ClonOrder.length > 0 ? Math.max(...ClonOrder.map(o => o.nOrder)) : 0;
                nMaxC = nMaxC + 1;
                obj = {
                    nID: nMaxC,
                    sID: nMaxC + "",
                    nOrder: (isNaN(nNoC) ? 0 : nNoC) + 1,
                    nTargetID: nMaxC,
                    isNew: true,
                    nStrategicID: nStrategicID,
                    sTargetName: formTarget.getValues("sTargetStrategicName"),
                    sName: formTarget.getValues("sTargetStrategicName")
                }
            }

            old.lstChildren = [...ClonOrder, obj];
            old.lstChildren.sort((a, b) => a.nOrder - b.nOrder);
            lstChildren = old.lstChildren;

            setArrOptionOrderTarget([...arrOptionOrderTarget, { value: obj.nOrder + "", label: obj.nOrder, nID: nStrategicID }]);

            lstData = [...lstData.filter(f => f.nID !== nStrategicID), old];
        }
        lstData.sort((a, b) => a.nOrder - b.nOrder);
        let result = [...lstData];

        let arrData = []

        result.forEach(f => {
            let objOption = {
                value: f.nID,
                label: f.sName,
                nOrder: f.nOrder,
                sTopic: f.sTopic
            }

            arrData.push(objOption);
        })

        setArrOptionTarget(arrData);
        setDataRowTarget(result);

        //set data activity
        let lstActivty = [...dataRowActivity];
        let objActivity = lstActivty.find(f => f.nStrategicID === nStrategicID);
        if (objActivity) {
            objActivity.lstTarget = lstChildren;
        }

        let resultActivity = [...lstActivty.filter(f => f.nStrategicID !== nStrategicID), objActivity];
        resultActivity = resultActivity.slice().sort((a, b) => a.nOrder - b.nOrder);

        setDataRowActivity(resultActivity);

        formTarget.setValue("sTargetStrategicName", null);
        setNEditTarget(null);
    }

    const handleSubmitCommittee = () => {
        let lstData = [...dataRowCommittee];
        let nMax = lstData.length > 0 ? Math.max(...lstData.map(o => o.nID)) : 0;
        nMax = nMax + 1;

        let sName = formBoardMeetingTable.getValues("sTopic");

        let obj = lstData.find(f => f.nID === nEditCommittee);

        if (obj) {
            obj.sName = sName;
            obj.sTopic = sName;
            obj.lstChildren = [];
        } else {
            obj = {
                nID: nMax,
                sID: nMax + "",
                nMeetingID: nMax,
                isNew: true,
                nOrder: lstData.length + 1,
                sName: sName,
                sTopic: sName,
                IsHead: true,
                lstChildren: []
            }
        }

        let nOrder = 1;
        let isSave = true;
        arrBoardMeeting.forEach(f => {
            let nGroupMeeting = formBoardMeeting.getValues(`sGroupMeeting_${f.nID}`);
            let dDateStart = moment(formBoardMeeting.getValues(`sStartMonthMeeting_${f.nID}`));
            let dDateEnd = moment(formBoardMeeting.getValues(`sEndMonthMeeting_${f.nID}`));

            if (nGroupMeeting && dDateStart.isValid() && dDateEnd.isValid()) {
                let sNameGroup = arrOptionCommittee.find(f => f.value === nGroupMeeting)?.label;

                let nUnixTimeStart = ConvertDateToUnixOrNull(dDateStart.startOf('month').year(nYear));
                let nUnixTimeEnd = ConvertDateToUnixOrNull(dDateEnd.endOf('month').year(nYear));
                let sDateStart = Convert.DateTimeToString(dDateStart.format("YYYY-MM-DD"), "MMMM YYYY", "th");
                let sDateEnd = Convert.DateTimeToString(dDateEnd.format("YYYY-MM-DD"), "MMMM YYYY", "th");
                let sDate = "เดือน" + sDateStart;

                if (sDateStart !== sDateEnd) {
                    sDate += ((dDateStart.isValid() ? " - " : "") + "เดือน" + sDateEnd);
                }

                let objChildren = {
                    nID: f.nID,
                    sID: f.sID + "",
                    nMeetingGroupID: f.nID,
                    isNew: true,
                    nOrder: nOrder++,
                    nMeetingID: obj.nID,
                    sMeetingName: obj.sName,
                    nCommitteeGroupID: nGroupMeeting,
                    sName: sNameGroup,
                    sDate: sDate,
                    nUnixTimeStart: nUnixTimeStart,
                    nUnixTimeEnd: nUnixTimeEnd
                }

                obj.lstChildren = [...obj.lstChildren, objChildren];
            } else {
                isSave = false;
            }
        })

        if (isSave) {
            lstData = lstData.filter(f => f.nID !== nEditCommittee);
            lstData = [...lstData, obj];
            setDataRowCommittee(lstData);
            formBoardMeetingTable.setValue("sTopic", null);
            formBoardMeeting.reset();
            setArrBoardMeeting(defaultBoardMeeting);
            setTrigger(trigger + 1);
            setNEditCommittee(null);
        } else {
            document.getElementById("AddBoard").click();
        }
    }
    const handleEditCommittee = (nID) => {
        let clone = [...dataRowCommittee];
        let obj = clone.find(f => f.nID === nID);

        if (obj) {
            formBoardMeetingTable.setValue("sTopic", obj.sName);
            let lstChildren = [...obj.lstChildren];

            let arrAdd = [];

            lstChildren.forEach(f => {
                formBoardMeeting.setValue(`sGroupMeeting_${f.nID}`, f.nCommitteeGroupID);
                formBoardMeeting.setValue(`sStartMonthMeeting_${f.nID}`, moment(f.nUnixTimeStart));
                formBoardMeeting.setValue(`sEndMonthMeeting_${f.nID}`, moment(f.nUnixTimeEnd));

                let board = {
                    nID: f.nID,
                    sID: f.nID + ""
                }

                arrAdd.push(board);
            });

            setArrBoardMeeting(arrAdd);
            setNEditCommittee(nID);
        }
    }

    const handleSubmitActivity = () => {

        // setNProjectCurrent(null);

        let nProjectID = formActivity.getValues("sActivityProject");
        let sActivityName = formActivity.getValues("sActivityName");
        let sBudget = formActivity.getValues("sBudget");
        let nObjBudget = "0.00";

        if (parseFloatCheckValue(sBudget)) {
            nObjBudget = formatNumber(parseFloat(sBudget), 2);
        }

        let objDuration = formDuration.getValues();
        if (Object.values(objDuration).filter(f => f == null).length > 0) {
            document.getElementById("AddDuration").click();
        } else if (nEditActivity && nEditActivityProject) {
            let clone = [...dataRowActivity];
            let arrClone = clone.filter(x => x.lstStrategy.some(c => c.lstProject.some(r => r.nID === nEditActivityProject)));
            let nParentID = null;

            if (isSubActivity) {
                let lastes = arrActivity[arrActivity.length - 1];
                nParentID = formActivity.getValues("sUnderActivity_" + lastes.nID);

                if (!nParentID && arrActivity.length > 1) {
                    lastes = arrActivity[arrActivity.length - 2];
                    nParentID = formActivity.getValues("sUnderActivity_" + lastes.nID);
                }
            }

            arrClone.forEach(item => {
                [...item.lstStrategy].forEach(strategy => {
                    [...strategy.lstProject].forEach(project => {
                        if (project.nProjectID === nEditActivityProject) {
                            let objActivity = [...project.lstActivity].find(f => f.nID === nEditActivity);

                            if (objActivity) {
                                objActivity.lstAssign = [...dataRowAssign];
                                objActivity.lstMeeting = [...dataRowCommittee];

                                let allMonth = moment.months();
                                let arrDurationData = [];
                                let arrMonthCheck = [];
                                let arrMonthDuration = [];
                                arrDuration.forEach(f => {
                                    let start = moment(formDuration.getValues("sStartMonth_" + f.nID))
                                    let end = moment(formDuration.getValues("sEndMonth_" + f.nID))

                                    let arr = {
                                        nID: f.nID,
                                        sID: f.nID + "",
                                        nWorkActivityPeriodID: f.nID,
                                        nActivityID: objActivity.nActivityID,
                                        nUnixTimeStart: start.isValid() ? ConvertDateToUnixOrNull(start.startOf('month').year(nYear)) : null,
                                        nUnixTimeEnd: end.isValid() ? ConvertDateToUnixOrNull(end.endOf('month').year(nYear)) : null,
                                        sWeight: formDuration.getValues("sWeight_" + f.nID) + "",
                                        sSumWeight: null,
                                    }

                                    let nDiff = moment(arr.nUnixTimeEnd).diff(moment(arr.nUnixTimeStart), "month");
                                    if (!isNaN(nDiff)) {
                                        let nWeightDiff = (parseFloat(arr.sWeight) * (nDiff + 1));
                                        arr.sSumWeight = formatNumber(nWeightDiff, 2);
                                    }

                                    arrDurationData.push(arr);

                                    if (start.isValid() && end.isValid()) {
                                        let nStartMonth = parseInt(start.format("M"));
                                        let nEndMonth = parseInt(end.format("M"));
                                        let date = [...allMonth.slice(nStartMonth - 1, nEndMonth)].map(m => parseInt(moment().month(m).format("M")))
                                        arrMonthCheck.push(...date);
                                    }
                                })

                                allMonth.forEach(m => {
                                    let nMonth = parseInt(moment().month(m).format("M"));

                                    let month = {
                                        nMonth: nMonth,
                                        IsChecked: arrMonthCheck.filter(f => f === nMonth).length > 0
                                    }

                                    arrMonthDuration.push(month);
                                })
                                let nSum = [...arrDurationData].map(m => parseFloat(m.sSumWeight)).reduce((a, b) => a + b, 0);

                                objActivity.sWeight = formatNumber(nSum, 2);
                                objActivity.lstDuration = arrDurationData;
                                objActivity.lstMonth = arrMonthDuration;

                                let nMaxDate = _.maxBy(arrDurationData, 'nUnixTimeEnd')?.nUnixTimeEnd;
                                let nMinDate = _.minBy(arrDurationData, 'nUnixTimeStart')?.nUnixTimeStart;

                                objActivity.sActivityName = sActivityName;
                                objActivity.isSubActivity = isSubActivity;
                                objActivity.isCommitteeMeeting = isBoardMeeting;
                                objActivity.sBudget = nObjBudget + "";
                                objActivity.nParentID = nParentID;
                                objActivity.nUnixTimeStart = nMaxDate;
                                objActivity.nUnixTimeEnd = nMinDate;

                                [...project.lstMonth].forEach(f => {
                                    if (!f.IsChecked) {
                                        f.IsChecked = arrMonthDuration.find(m => m.nMonth === f.nMonth)?.IsChecked ?? false;
                                    }
                                });

                                let objData = project.lstActivity.find(f => f.nID === nParentID);
                                let nLevel = 0;

                                if (objData) {
                                    nLevel = objData.nLevel;
                                    objActivity.sOrder = objData.sOrder + "." + objActivity.nOrder;
                                }

                                objActivity.nLevel = nLevel + 1;

                                [...project.lstActivity].forEach(item => {
                                    if (item.nActivityID === objActivity.nParentID) {
                                        item.lstAssign = [];
                                    }

                                    let nChildren = [...project.lstActivity].filter(f => f.nParentID === objActivity.nActivityID).length;
                                    if (nChildren > 0) {
                                        objActivity.lstAssign = [];
                                    }
                                });

                                let nWeight = [...project.lstActivity].filter(f => f.nParentID === null).filter(f => f.nID !== objActivity.nID).map(m => parseFloat(m.sWeight) || 0).reduce((a, b) => a + b, 0);
                                let nBudget = [...project.lstActivity].filter(f => f.nParentID === null).filter(f => f.nID !== objActivity.nID).map(m => parseFloat((m.sBudget + "").replace(/,/g, '')) || 0).reduce((a, b) => a + b, 0);

                                if (!objActivity.isSubActivity) {
                                    project.sWeight = formatNumber((nWeight + nSum), 2);
                                    project.sBudget = formatNumber((nBudget + parseFloat((objActivity.sBudget + "").replace(/,/g, '') ?? "0.00")), 2);
                                }
                                let data = [...[...project.lstActivity].filter(f => f.nID !== nEditActivity), objActivity];

                                data = data.sort((a, b) => a.sOrder.localeCompare(b.sOrder, undefined, { numeric: true, sensitivity: 'base' }));
                                project.lstActivity = [...data];

                                let arrOption = {
                                    label: objActivity.sOrder + " " + objActivity.sActivityName,
                                    value: objActivity.nID,
                                    nProjectID: objActivity.nProjectID,
                                    nParentID: nParentID,
                                    nLevel: objActivity.nLevel,
                                    nMaxDate: nMaxDate,
                                    nMinDate: nMinDate,
                                    nBudget: parseFloat((objActivity.sBudget + "").replace(/,/g, '')),
                                    nWeight: parseFloat((objActivity.sWeight + "").replace(/,/g, ''))
                                }
                                setDataOptionActivity([...dataOptionActivity.filter(f => f.value !== nEditActivity && f.nProjectID !== nEditActivityProject), arrOption]);
                            }
                        }
                    })
                })
            });

            clone = clone.slice().sort((a, b) => a.nOrder - b.nOrder);
            setDataRowActivity([...clone]);

            //set data
            resetActivity();
        } else {
            let lstData = [...dataRowActivity];
            let query = lstData.filter(x => x.lstStrategy.some(c => c.lstProject.some(r => r.nID === nProjectID)));
            let nParentID = null;
            let option = [];
            let allMonth = moment.months();


            if (isSubActivity) {
                let lastes = arrActivity[arrActivity.length - 1];
                nParentID = formActivity.getValues("sUnderActivity_" + lastes.nID);

                if (!nParentID && arrActivity.length > 1) {
                    lastes = arrActivity[arrActivity.length - 2];
                    nParentID = formActivity.getValues("sUnderActivity_" + lastes.nID);
                }
            }

            let obj = {
                nID: 0,
                sID: "",
                nOrder: 1,
                nProjectID: nProjectID,
                nActivityID: 0,
                isNew: true,
                sActivityName: sActivityName,
                isSubActivity: isSubActivity,
                isCommitteeMeeting: isBoardMeeting,
                sWeight: null,
                sBudget: nObjBudget + "",
                nParentID: nParentID,
                nLevel: 0,
                sOrder: null,
                lstDuration: [],
                lstMonth: [],
                lstMeeting: [...dataRowCommittee],
                lstAssign: [...dataRowAssign],
                nUnixTimeStart: null,
                nUnixTimeEnd: null
            }
            let nMax = nMaxActivity;

            query.forEach(item => {
                [...item.lstStrategy].forEach(strategy => {
                    [...strategy.lstProject].forEach(project => {
                        if (project.nProjectID === nProjectID) {

                            let nID = 1;
                            let arrDurationData = [];
                            let arrMonthCheck = [];
                            let arrMonthDuration = [];
                            arrDuration.forEach(f => {
                                nID = nID + 1;
                                let start = moment(formDuration.getValues("sStartMonth_" + f.nID))
                                let end = moment(formDuration.getValues("sEndMonth_" + f.nID))

                                let arr = {
                                    nID: nID,
                                    sID: nID + "",
                                    nWorkActivityPeriodID: nID,
                                    nActivityID: obj.nActivityID,
                                    nUnixTimeStart: start.isValid() ? ConvertDateToUnixOrNull(start.startOf('month').year(nYear)) : null,
                                    nUnixTimeEnd: end.isValid() ? ConvertDateToUnixOrNull(end.endOf('month').year(nYear)) : null,
                                    sWeight: formDuration.getValues("sWeight_" + f.nID) + "",
                                    sSumWeight: null,
                                }

                                let nDiff = moment(arr.nUnixTimeEnd).diff(moment(arr.nUnixTimeStart), "month");
                                if (!isNaN(nDiff)) {
                                    arr.sSumWeight = formatNumber((parseFloat(arr.sWeight) * (nDiff + 1)), 2);
                                }

                                arrDurationData.push(arr);

                                if (start.isValid() && end.isValid()) {
                                    let nStartMonth = parseInt(start.format("M"));
                                    let nEndMonth = parseInt(end.format("M"));
                                    let date = [...allMonth.slice(nStartMonth - 1, nEndMonth)].map(m => parseInt(moment().month(m).format("M")))
                                    arrMonthCheck.push(...date);
                                }
                            })

                            let nMaxDate = _.maxBy(arrDurationData, 'nUnixTimeEnd')?.nUnixTimeEnd;
                            let nMinDate = _.minBy(arrDurationData, 'nUnixTimeStart')?.nUnixTimeStart;

                            nMax = nMax + 1;
                            let nOrder = DefaultArrayEmpty(project.lstActivity).length > 0 ? Math.max(...project.lstActivity.filter(f => f.nParentID === null).map(o => o.nOrder)) : 0;
                            nOrder = nParentID ? 1 : nOrder + 1;

                            obj.nID = nMax;
                            obj.sID = nMax + "";
                            obj.nActivityID = nMax;
                            obj.nOrder = nOrder;
                            obj.sOrder = (project.sOrder ?? 1) + "." + nOrder;
                            //// obj.lstAssign = obj.lstAssign ?? project.lstAssign;
                            obj.nUnixTimeStart = nMaxDate;
                            obj.nUnixTimeEnd = nMinDate;

                            ////project.lstAssign = obj.lstAssign;
                            allMonth.forEach(m => {
                                let nMonth = parseInt(moment().month(m).format("M"));

                                let month = {
                                    nMonth: nMonth,
                                    IsChecked: arrMonthCheck.filter(f => f === nMonth).length > 0
                                }

                                arrMonthDuration.push(month);
                            })
                            let nSum = [...arrDurationData].map(m => parseFloat(m.sSumWeight)).reduce((a, b) => a + b, 0);
                            obj.sWeight = formatNumber(nSum, 2);
                            obj.lstDuration = arrDurationData;
                            obj.lstMonth = arrMonthDuration;

                            [...project.lstMonth].forEach(f => {
                                if (!f.IsChecked) {
                                    f.IsChecked = arrMonthDuration.find(m => m.nMonth === f.nMonth)?.IsChecked ?? false;
                                }
                            });

                            let arrCh = [...project.lstActivity.filter(f => f.nParentID === nParentID)];
                            if (arrCh.length > 0) {
                                nOrder = Math.max(...arrCh.map(o => o.nOrder));
                                obj.nOrder = nOrder + 1;
                            }

                            let objData = project.lstActivity.find(f => f.nID === nParentID);
                            let nLevel = 0;

                            if (objData) {
                                nLevel = objData.nLevel;
                                obj.sOrder = objData.sOrder + "." + obj.nOrder;
                            }

                            obj.nLevel = nLevel + 1;

                            [...project.lstActivity].forEach(item => {
                                if (item.nActivityID === obj.nParentID) {
                                    if (obj.lstAssign.length <= 0) {
                                        obj.lstAssign = item.lstAssign
                                    }
                                    item.lstAssign = [];
                                }
                            });
                            let nWeight = [...project.lstActivity].filter(f => f.nParentID === null).map(m => parseFloat(m.sWeight) || 0).reduce((a, b) => a + b, 0);
                            let nBudget = [...project.lstActivity].filter(f => f.nParentID === null).map(m => parseFloat(m.sBudget.replace(/,/g, '')) || 0).reduce((a, b) => a + b, 0);

                            if (!obj.isSubActivity) {
                                project.sWeight = formatNumber((nWeight + nSum), 2);
                                project.sBudget = formatNumber((nBudget + parseFloat((obj.sBudget).replace(/,/g, '') ?? "0.00")), 2);
                            }

                            let data = [...project.lstActivity, obj];

                            data = data.sort((a, b) => a.sOrder.localeCompare(b.sOrder, undefined, { numeric: true, sensitivity: 'base' }));
                            project.lstActivity = [...data];


                            let arrOption = {
                                label: obj.sOrder + " " + obj.sActivityName,
                                value: obj.nID,
                                nProjectID: obj.nProjectID,
                                nParentID: nParentID,
                                nLevel: obj.nLevel,
                                nMaxDate: nMaxDate,
                                nMinDate: nMinDate,
                                nBudget: parseFloat((obj.sBudget + "").replace(/,/g, '')),
                                nWeight: parseFloat((obj.sWeight + "").replace(/,/g, ''))
                            }

                            option.push(arrOption);
                        }

                    })
                })
            });
            setNMaxActivity(nMax);
            setDataOptionActivity([...dataOptionActivity, ...option]);

            lstData = lstData.slice().sort((a, b) => a.nOrder - b.nOrder);
            setDataRowActivity([...lstData]);


            //set data
            resetActivity();
        }

        setNMaxMonth(null);
        setNMinMonth(null);
        setNMaxBudget(null);
        setNMaxWeight(null);
        setNParentID(null);
    }

    const handleSubmitStrategy = () => {

        let lstData = [...dataRowStrategy];
        let nStrategicID = formStrategy.getValues("sStrategyStrategic");
        let sStrategic = arrOptionStrategic.find(f => f.value === nStrategicID);
        let lstChildren = [];

        if (sStrategic) {

            let old = lstData.find(f => f.nID === nStrategicID);

            if (!old) {
                old = {
                    nID: nStrategicID,
                    sID: nStrategicID + "",
                    nOrder: sStrategic.nOrder,
                    sOrder: sStrategic.nOrder + "",
                    nStrategicID: nStrategicID,
                    sName: sStrategic.label,
                    sTopic: sStrategic.sTopic,
                    IsHead: true,
                    lstChildren: []
                }
            }

            old.sName = sStrategic.label;
            old.sTopic = sStrategic.sTopic;
            old.nOrder = sStrategic.nOrder;
            old.sOrder = sStrategic.nOrder + "";

            let ClonChildren = [].concat(...lstData.map(m => m.lstChildren));
            let ClonOrder = old.lstChildren;

            let obj = ClonChildren.find(f => f.nID === nEditStrategy);
            if (obj) {
                if (obj.nStrategicID !== nStrategicID) {
                    let oldStrategic = lstData.find(f => f.nID === obj.nStrategicID);
                    if (oldStrategic) {
                        oldStrategic.lstChildren = oldStrategic.lstChildren.filter(f => f.nID !== obj.nID);
                        let nOrder = 1;
                        oldStrategic.lstChildren.forEach(f => {
                            f.nOrder = nOrder++;
                            f.sOrder = oldStrategic.nOrder + "." + f.nOrder;
                        });
                        let lstActivty = [...dataRowActivity];
                        let objActivity = lstActivty.find(f => f.nStrategicID === obj.nStrategicID);
                        if (objActivity) {
                            objActivity.lstStrategy = oldStrategic.lstChildren;
                        }
                    }
                    obj.nOrder = ClonOrder.length + 1;
                    obj.sOrder = sStrategic.nOrder + "." + obj.nOrder;
                } else {
                    ClonOrder = ClonOrder.filter(f => f.nID !== obj.nID)
                }
                let sNoTopic = `${I18n.SetText("FundPlan.Strategy")}${I18n.SetText("FundPlan.No")} ${obj.sOrder} `;
                let sStrategyName = formStrategy.getValues("sStrategyName");

                obj.nStrategicID = nStrategicID;
                obj.sStrategyName = sStrategyName;
                obj.sName = sStrategyName;
                obj.sTopic = "<b>" + sNoTopic + "</b>" + sStrategyName;
                obj.sNoTopic = sNoTopic;

                let dataProject = [...dataRowProject];
                let project = dataProject.find(f => f.nID === nEditStrategy);

                if (project) {
                    project.sName = obj.sNoTopic + "" + obj.sName;
                    project.sTopic = obj.sTopic;
                    project.nOrder = obj.nOrder;
                    project.nStrategyID = obj.nID;

                    dataProject.sort((a, b) => a.nOrder - b.nOrder);
                }

            } else {

                let nMaxC = ClonChildren.length > 0 ? Math.max(...ClonChildren.map(o => o.nID)) : 0;

                let nNoC = ClonOrder.length + 1;
                nMaxC = nMaxC + 1;
                let sOrder = sStrategic.nOrder + "." + nNoC;

                let sNoTopic = `${I18n.SetText("FundPlan.Strategy")}${I18n.SetText("FundPlan.No")} ${sOrder} `;
                let sStrategyName = formStrategy.getValues("sStrategyName");

                obj = {
                    nID: nMaxC,
                    sID: nNoC + "",
                    nOrder: nNoC,
                    sOrder: sOrder,
                    nStrategyID: nMaxC,
                    isNew: true,
                    nStrategicID: nStrategicID,
                    sStrategyName: sStrategyName,
                    sName: sStrategyName,
                    sTopic: "<b>" + sNoTopic + "</b>" + sStrategyName,
                    sNoTopic: sNoTopic,
                    lstProject: []
                }
            }

            old.lstChildren = [...ClonOrder, obj];
            old.lstChildren.sort((a, b) => a.nOrder - b.nOrder);
            lstChildren = old.lstChildren;

            setArrOptionOrderStrategy([...arrOptionOrderStrategy, { value: obj.nOrder + "", label: obj.sOrder, nID: nStrategicID }]);

            lstData = [...lstData.filter(f => f.nID !== nStrategicID), old];
        }
        lstData.sort((a, b) => a.nOrder - b.nOrder);
        let result = [...lstData];

        let arrData = []

        result = result.sort((a, b) => a.nOrder - b.nOrder);

        let option = [].concat(...result.map(m => m.lstChildren));

        option = option.sort((a, b) => a.sOrder - b.sOrder);

        option.forEach(f => {
            let objOption = {
                value: f.nID,
                label: f.sNoTopic + " " + f.sName,
                nOrder: f.nOrder,
                sTopic: f.sTopic
            }

            arrData.push(objOption);
        })

        setArrOptionStrategy(arrData);
        setDataRowStrategy(result);

        //set data activity
        let lstActivty = [...dataRowActivity];
        let objActivity = lstActivty.find(f => f.nStrategicID === nStrategicID);
        if (objActivity) {
            objActivity.lstStrategy = lstChildren;
        }

        let activity = [...lstActivty.filter(f => f.nStrategicID !== nStrategicID), objActivity];
        activity = activity.slice().sort((a, b) => a.nOrder - b.nOrder);
        setDataRowActivity(activity);

        formStrategy.setValue("sStrategyName", null);
        setNEditStrategy(null);
    }

    const isObject = (value) => {
        return (
            typeof value === 'object' &&
            value !== null &&
            !Array.isArray(value)
        );
    }

    const isObjectEmpty = (objectName) => {
        return Object.keys(objectName).length === 0
    }

    const handleSubmitProject = () => {
        let obj = {} as any;
        if (nEditProject) {
            let arrClone = [].concat(...dataRowProject.map(m => m.lstChildren));
            obj = arrClone.find((f) => f.nID === nEditProject);
        }
        let lstData = [...dataRowProject];
        let nStrategyID = formProject.getValues("sProjectStrategy");
        let sStrategy = arrOptionStrategy.find(f => f.value === nStrategyID);
        let nStrategicID = null;
        let lstChildren = [];

        if (sStrategy) {

            let old = lstData.find(f => f.nID === nStrategyID);
            nStrategicID = [].concat(...dataRowStrategy.map(m => m.lstChildren)).find(f => f.nID === nStrategyID)?.nStrategicID;

            if (!old) {
                old = {
                    nID: nStrategyID,
                    sID: nStrategyID + "",
                    nOrder: sStrategy.nOrder,
                    nStrategyID: nStrategyID,
                    sName: sStrategy.label,
                    sTopic: sStrategy.sTopic,
                    IsHead: true,
                    lstChildren: []
                }
            }

            let ClonChildren = [].concat(...lstData.map(m => m.lstChildren));
            let ClonOrder = [...old.lstChildren];

            let sProjectName = formProject.getValues("sProjectName");
            let lstProjectIndicator = formProject.getValues("sIndicatorRef");
            let arrIndi = isObject(lstProjectIndicator) ? Object.keys(lstProjectIndicator).map(m => parseInt(m)) : [];

            if (obj && !isObjectEmpty(obj)) {

                if (obj.nStrategyID !== nStrategyID) {
                    let oldStrategy = lstData.find(f => f.nID === obj.nStrategyID);
                    if (oldStrategy) {
                        oldStrategy.lstChildren = oldStrategy.lstChildren.filter(f => f.nID !== obj.nID);
                    }
                    obj.nOrder = ClonOrder.length + 1;
                    obj.nOrder = obj.nOrder + "";
                } else {
                    ClonOrder = ClonOrder.filter(f => f.nID !== obj.nID)
                }

                let sNoTopic = `${I18n.SetText("FundPlan.Project")}${I18n.SetText("FundPlan.No")} ${obj.nOrder} `;

                obj.nStrategyID = nStrategyID;
                obj.sProjectName = sProjectName;
                obj.sName = sProjectName;
                obj.sTopic = sProjectName;
                obj.sNoTopic = sNoTopic;
                obj.sTargetUnit = formProject.getValues("sTargetUnit");
                obj.lstProjectIndicator = arrIndi;
                obj.sOutputQuantitative = formProject.getValues("sOutputQuantitative");
                obj.sOutputQualitative = formProject.getValues("sOutputQualitative");
                obj.sOutcomeQuantitative = formProject.getValues("sOutcomeQuantitative");
                obj.sOutcomeQualitative = formProject.getValues("sOutcomeQualitative");
                obj.sImpact = formProject.getValues("sImpact");
            } else {
                let nMaxC = ClonChildren.length > 0 ? Math.max(...ClonChildren.map(o => o.nID)) : 0;

                let nNoC = ClonOrder.length + 1;
                nMaxC = nMaxC + 1;
                let sNoTopic = `${I18n.SetText("FundPlan.Project")}${I18n.SetText("FundPlan.No")} ${nNoC} `;

                obj = {
                    nID: nMaxC,
                    sID: nNoC + "",
                    nOrder: nNoC,
                    sOrder: nNoC + "",
                    nStrategyID: nStrategyID,
                    nProjectID: nMaxC,
                    isNew: true,
                    sProjectName: sProjectName,
                    sName: sProjectName,
                    sTopic: sProjectName,
                    sNoTopic: sNoTopic,
                    sTargetUnit: formProject.getValues("sTargetUnit"),
                    lstProjectIndicator: arrIndi,
                    sOutputQuantitative: formProject.getValues("sOutputQuantitative"),
                    sOutputQualitative: formProject.getValues("sOutputQualitative"),
                    sOutcomeQuantitative: formProject.getValues("sOutcomeQuantitative"),
                    sOutcomeQualitative: formProject.getValues("sOutcomeQualitative"),
                    sImpact: formProject.getValues("sImpact"),
                    lstMonth: lstMonth,
                    lstActivity: [],
                    lstAssign: [],
                    sWeight: null,
                    sBudget: null

                }
            }

            old.lstChildren = [...ClonOrder, obj];
            old.lstChildren.sort((a, b) => a.nOrder - b.nOrder);
            lstChildren = old.lstChildren;

            setArrOptionOrderProject([...arrOptionOrderProject, { value: obj.nOrder + "", label: obj.nOrder, nID: nStrategyID }]);

            lstData = [...lstData.filter(f => f.nID !== nStrategyID), old];
        }
        lstData.sort((a, b) => a.nStrategyID - b.nStrategyID || a.nOrder - b.nOrder);
        let result = [...lstData];

        let arrData = []

        let option = [].concat(...result.map(m => m.lstChildren));

        option.forEach(f => {
            let objOption = {
                value: f.nID,
                label: f.sName,
                nOrder: f.nOrder,
                sTopic: f.sTopic
            }

            arrData.push(objOption);
        })

        setArrOptionProject(arrData);
        setDataRowProject(result);

        //set data activity
        let lstActivty = [...dataRowActivity];
        let objActivity = lstActivty.find(f => f.nStrategicID === nStrategicID);
        if (objActivity) {
            objActivity.lstStrategy.filter(item => item.nStrategyID === nStrategyID).map(m => m.lstProject = [...lstChildren]);
        }

        let activity = [...lstActivty.filter(f => f.nStrategicID !== nStrategicID), objActivity];
        activity = activity.slice().sort((a, b) => a.nOrder - b.nOrder);
        setDataRowActivity(activity);

        formProject.setValue("sProjectName", null);
        formProject.setValue("sTargetUnit", null);
        formProject.setValue("sIndicatorRef", null);
        formProject.setValue("sOutputQuantitative", null);
        formProject.setValue("sOutputQualitative", null);
        formProject.setValue("sOutcomeQuantitative", null);
        formProject.setValue("sOutcomeQualitative", null);
        formProject.setValue("sImpact", null);
        handleChangeOptionSelectIndicator();
        setNEditProject(null);
    }

    const handleChangeOptionSelectIndicator = () => {
        let clone = [...arrOptionIndicator];
        clone.forEach(item => {
            item.icon = "pi pi-fw pi-stop";
            item.selectable = true;
            item.className = "";

            item.children.forEach(m => {
                m.icon = "pi pi-fw pi-stop";
                m.selectable = true;
                m.className = "";
            });
        })
    }

    const handleSubmitStrategic = () => {
        let lstData = [...dataRowStrategic];
        let obj = {} as any;

        if (nEditStrategic) {
            obj = lstData.find(f => f.nID === nEditStrategic);

            if (obj) {
                let sNoTopic = `${I18n.SetText("FundPlan.Strategic")}${I18n.SetText("FundPlan.No")} ${obj.nOrder} `;

                obj.sStrategicName = formStrategic.getValues("sStrategicName");
                obj.sName = obj.sStrategicName;
                obj.sTopic = "<b>" + sNoTopic + "</b>" + obj.sStrategicName;
                obj.sNoTopic = sNoTopic;
                lstData = lstData.filter(f => f.nID !== nEditStrategic);

                let dataStrategy = [...dataRowStrategy];
                let dataTarget = [...dataRowTarget];
                let old = dataStrategy.find(f => f.nID === nEditStrategic);
                let target = dataTarget.find(f => f.nID === nEditStrategic);

                if (target) {
                    target.sName = obj.sNoTopic + "" + obj.sName;
                    target.sTopic = obj.sTopic;
                    target.nOrder = obj.nOrder;
                    target.sOrder = obj.nOrder + "";
                }
                if (old) {
                    old.sName = obj.sNoTopic + "" + obj.sName;
                    old.sTopic = obj.sTopic;
                    old.nOrder = obj.nOrder;
                    old.sOrder = obj.nOrder + "";
                }
            }
        } else {
            let nMax = lstData.length > 0 ? Math.max(...lstData.map(o => o.nID)) : 0;
            let nNo = lstData.length > 0 ? Math.max(...lstData.map(o => o.nOrder)) : 0;

            nMax = nMax + 1;
            let nOrder = (isNaN(nNo) ? 0 : nNo) + 1;
            let sNoTopic = `${I18n.SetText("FundPlan.Strategic")}${I18n.SetText("FundPlan.No")} ${nOrder} `;
            let sStrategicName = formStrategic.getValues("sStrategicName");

            obj = {
                nID: nMax,
                sID: nMax + "",
                nOrder: nOrder,
                nStrategicID: nMax,
                isNew: true,
                sStrategicName: sStrategicName,
                sName: sStrategicName,
                sTopic: "<b>" + sNoTopic + "</b>" + sStrategicName,
                sNoTopic: sNoTopic,
                lstTarget: [],
                lstStrategy: []
            }
            setArrOptionOrderStrategic([...arrOptionOrderStrategic, { value: obj.nOrder + "", label: obj.nOrder }]);
        }

        let result = [...lstData, obj];

        let arrData = []
        result = result.sort((a, b) => a.nOrder - b.nOrder);

        result.forEach(f => {
            let objOption = {
                value: f.nID,
                label: f.sNoTopic + "" + f.sName,
                nOrder: f.nOrder,
                sTopic: f.sTopic,
                sNoTopic: f.sNoTopic
            }

            arrData.push(objOption);
        })

        setArrOptionStrategic(arrData);
        setDataRowStrategic(result)

        //data activity

        setDataRowActivity(result);

        formStrategic.setValue("sStrategicName", null);
        setNEditStrategic(null);
    }

    const handleSubmitAssign = () => {
        let lstData = [...dataRowAssign];
        let nUserID = formAssign.getValues("sAssignPerson");

        if (nUserID?.value) {
            let nID = nUserID.value;
            let sName = nUserID.label;
            let dDate = moment(formAssign.getValues("sDueDate"));
            let nUnixTime = null;
            let sDate = null;

            if (dDate.isValid()) {
                nUnixTime = ConvertDateToUnixOrNull(dDate);
                sDate = dDate.add(543, 'year').format("DD/MM/YYYY")
            }

            let obj = [...lstData].find(f => f.nID === nEditAssign);
            lstData = lstData.filter(f => f.nUserID !== nID);



            if (obj) {
                obj.nUserID = nID;
                obj.sName = sName;
                obj.sDate = sDate;
                obj.nUnixTime = nUnixTime;
            } else {
                obj = {
                    nID: nID,
                    sID: nID + "",
                    nOrder: lstData.length + 1,
                    nUserID: nID,
                    sName: sName,
                    sDate: sDate,
                    nUnixTime: nUnixTime
                }
            }
            lstData = lstData.filter(f => f.nID !== nEditAssign);
            lstData = [...lstData, obj]
        }

        setDataRowAssign(lstData);
        formAssign.setValue("sAssignPerson", null);
        formAssign.setValue("sDueDate", null);
        setNEditAssign(null);
    }

    const handleEditAssign = (nID) => {
        let clone = [...dataRowAssign];
        let obj = clone.find(f => f.nID === nID);

        if (obj) {
            formAssign.setValue("sAssignPerson", { value: obj.nUserID, label: obj.sName });
            formAssign.setValue("sDueDate", moment(obj.nUnixTime));
            setNEditAssign(nID);
        }
    }

    const onAddDuration = () => {
        let nMax = Math.max(...arrDuration.map(o => o.nID));
        nMax = nMax + 1;
        let obj = {
            nID: nMax,
            sID: nMax + ""
        }

        let arrAdd = [...arrDuration, obj];
        setArrDuration(arrAdd);
    }

    const onDeleteDuration = (nID) => {
        let arrDel = arrDuration.filter(f => f.nID !== nID);
        setArrDuration(arrDel);
    }

    const onAddBoardMeeting = () => {
        let nMax = Math.max(...arrBoardMeeting.map(o => o.nID));
        nMax = nMax + 1;
        let obj = {
            nID: nMax,
            sID: nMax + ""
        }

        let arrAdd = [...arrBoardMeeting, obj];
        setArrBoardMeeting(arrAdd);
    }

    const onDeleteBoardMeeting = (nID) => {
        let arrDel = arrBoardMeeting.filter(f => f.nID !== nID);
        setArrBoardMeeting(arrDel);
    }

    const onDeleteGoal = (nID) => {
        DialogFn.Submit("คุณการลบข้อมูลใช่หรือไม่?", () => {
            DialogFn.CloseSubmit();
            let arrClone = dataRowGoal;
            arrClone = arrClone.filter((f) => f.nID !== nID);
            let arrOption = [];
            //เรียง Order ใหม่
            if (arrClone.length > 0) {
                let nOrder = 1;
                arrClone.forEach((f) => {
                    f.nOrder = nOrder;
                    arrOption.push({
                        value: nOrder,
                        label: nOrder + "",
                    });
                    nOrder++;
                });
            }

            if (nID === nEditGoal) {
                setNEditGoal(null);
            }

            setDataRowGoal([...arrClone]);

            setArrOptionOrderGoal([...arrOption]);
        })
    }

    const onDeleteStrategic = (nID) => {
        DialogFn.Submit("คุณการลบข้อมูลใช่หรือไม่?", () => {
            DialogFn.CloseSubmit();
            let arrClone = dataRowStrategic;
            arrClone = arrClone.filter((f) => f.nID !== nID);
            let arrOption = [];
            //เรียง Order ใหม่
            if (arrClone.length > 0) {
                let nOrder = 1;
                arrClone.forEach((f) => {
                    f.nOrder = nOrder;
                    arrOption.push({
                        value: nOrder,
                        label: nOrder + "",
                    });
                    nOrder++;
                });
            }

            setDataRowStrategic([...arrClone]);

            setArrOptionOrderStrategic([...arrOption]);

            let arrData = [];

            arrClone.forEach(f => {
                let sNoTopic = `${I18n.SetText("FundPlan.Strategic")}${I18n.SetText("FundPlan.No")} ${f.nOrder} `;
                let objOption = {
                    value: f.nID,
                    label: f.sName,
                    nOrder: f.nOrder,
                    sTopic: "<b>" + sNoTopic + "</b>" + f.sName,
                    sNoTopic: sNoTopic
                }

                arrData.push(objOption);
            })

            setArrOptionStrategic(arrData);

            //data activity
            arrClone = arrClone.slice().sort((a, b) => a.nOrder - b.nOrder);
            setDataRowActivity([...arrClone]);

            if (nEditStrategic === nID) {
                setNEditStrategic(null);
            }
        })
    }

    const onDeleteTarget = (nID) => {
        DialogFn.Submit("คุณการลบข้อมูลใช่หรือไม่?", () => {
            DialogFn.CloseSubmit();
            let arrClone = [].concat(...dataRowTarget.map(m => m.lstChildren));
            let dataTarget = [...arrClone].filter((f) => f.nID === nID);
            arrClone = arrClone.filter((f) => f.nID !== nID);
            let newData = [];
            //เรียง group ใหม่
            let arrOption = [];

            arrClone.forEach(item => {
                let arr = newData.find(f => f.nStrategicID === item.nStrategicID);
                if (arr) {
                    let nMax = Math.max(...arr.lstChildren.map(o => o.nOrder));

                    item.nOrder = nMax + 1;

                    arrOption.push({
                        value: item.nOrder,
                        label: item.nOrder + "",
                        nID: item.nStrategicID
                    });

                    arr.lstChildren = [...arr.lstChildren, item]
                } else {
                    arr = dataRowTarget.find(f => f.nStrategicID === item.nStrategicID);

                    if (arr) {
                        item.nOrder = 1;
                        arrOption.push({
                            value: item.nOrder,
                            label: item.nOrder + "",
                            nID: item.nStrategicID
                        });

                        arr.lstChildren = [item]
                        newData.push(arr);
                    }
                }
            })

            let arrData = []

            let lstActivty = [...dataRowActivity];

            dataTarget.forEach(f => {
                let objOption = {
                    value: f.nID,
                    label: f.sName,
                    nOrder: f.nOrder,
                    sTopic: f.sTopic
                }

                arrData.push(objOption);

                //set data activity
                let objActivity = lstActivty.find(item => item.nStrategicID === f.nStrategicID);
                if (objActivity) {
                    objActivity.lstTarget = [...objActivity.lstTarget].filter(ch => ch.nID !== nID);
                }

                let activity = [...lstActivty.filter(a => a.nStrategicID !== f.nStrategicID), objActivity];
                activity = activity.slice().sort((a, b) => a.nOrder - b.nOrder);
                setDataRowActivity(activity);
            })

            setArrOptionTarget(arrData);

            setDataRowTarget([...newData]);

            setArrOptionOrderTarget([...arrOption]);

            if (nID === nEditTarget) {
                setNEditTarget(null);
            }
        })
    }

    const onDeleteAssign = (nID) => {
        DialogFn.Submit("คุณการลบข้อมูลใช่หรือไม่?", () => {
            DialogFn.CloseSubmit();
            let arrClone = [...dataRowAssign.filter(f => f.nID !== nID)];
            let nOrder = 1;
            arrClone.forEach(f => {
                f.nOrder = nOrder++;
            })
            setDataRowAssign(arrClone);
        })
    }

    const onDeleteCommittee = (nID) => {
        DialogFn.Submit("คุณการลบข้อมูลใช่หรือไม่?", () => {
            DialogFn.CloseSubmit();
            let arrClone = [...dataRowCommittee.filter(f => f.nID !== nID)];
            let nOrder = 1;
            arrClone.forEach(f => {
                f.nOrder = nOrder++;
            })
            setDataRowCommittee(arrClone);

            if (nID === nEditCommittee) {
                setNEditCommittee(null);
            }
        })
    }

    const onDeleteStrategy = (nID) => {
        DialogFn.Submit("คุณการลบข้อมูลใช่หรือไม่?", () => {
            DialogFn.CloseSubmit();
            let arrClone = [].concat(...dataRowStrategy.map(m => m.lstChildren));
            let dataStrategy = [...arrClone].filter((f) => f.nID === nID);
            arrClone = arrClone.filter((f) => f.nID !== nID);
            let newData = [];
            //เรียง group ใหม่
            let arrOption = [];

            arrClone.forEach(item => {
                let arr = newData.find(f => f.nStrategicID === item.nStrategicID);
                if (arr) {

                    let nMax = Math.max(...arr.lstChildren.map(o => o.nOrder));
                    item.nOrder = nMax + 1;
                    item.sOrder = arr.nOrder + "." + item.nOrder;
                    arrOption.push({
                        value: item.nOrder,
                        label: item.sOrder,
                        nID: item.nStrategicID
                    });

                    arr.lstChildren = [...arr.lstChildren, item]
                } else {
                    arr = dataRowStrategy.find(f => f.nStrategicID === item.nStrategicID);
                    if (arr) {
                        item.nOrder = 1;
                        item.sOrder = arr.nOrder + "." + item.nOrder;
                        arrOption.push({
                            value: item.nOrder,
                            label: item.sOrder,
                            nID: item.nStrategicID
                        });

                        arr.lstChildren = [item]
                        newData.push(arr);
                    }
                }
            })

            let arrData = []

            let option = [].concat(...newData.map(m => m.lstChildren));

            option.forEach(f => {
                f.sNoTopic = `${I18n.SetText("FundPlan.Strategy")}${I18n.SetText("FundPlan.No")} ${f.nOrder} `;
                let objOption = {
                    value: f.nID,
                    label: f.sNoTopic + "" + f.sName,
                    nOrder: f.nOrder,
                    sTopic: f.sTopic
                }

                arrData.push(objOption);
            })

            let lstActivty = [...dataRowActivity];

            dataStrategy.forEach(f => {
                let objOption = {
                    value: f.nID,
                    label: f.sName,
                    nOrder: f.nOrder,
                    sTopic: f.sTopic
                }

                arrData.push(objOption);

                //set data activity
                let objActivity = lstActivty.find(item => item.nStrategicID === f.nStrategicID);
                if (objActivity) {
                    objActivity.lstStrategy = [...objActivity.lstStrategy].filter(ch => ch.nID !== nID);
                }

                let activity = [...lstActivty.filter(a => a.nStrategicID !== f.nStrategicID), objActivity];
                activity = activity.slice().sort((a, b) => a.nOrder - b.nOrder);
                setDataRowActivity(activity);
            })

            setDataRowStrategy([...newData]);

            setArrOptionOrderStrategy([...arrOption]);
            setArrOptionStrategy(arrData);

            if (nEditStrategy === nID) {
                setNEditStrategy(null);
            }
        })
    }

    const onDeleteProject = (nID) => {
        DialogFn.Submit("คุณการลบข้อมูลใช่หรือไม่?", () => {
            DialogFn.CloseSubmit();
            let arrClone = [].concat(...dataRowProject.map(m => m.lstChildren));
            arrClone = arrClone.filter((f) => f.nID !== nID);
            let newData = [];
            //เรียง group ใหม่
            let arrOption = [];

            let lstActivty = [...dataRowActivity];

            arrClone.forEach(item => {
                let arr = newData.find(f => f.nStrategyID === item.nStrategyID);
                if (arr) {

                    let nMax = Math.max(...arr.lstChildren.map(o => o.nOrder));

                    item.nOrder = nMax + 1;
                    arrOption.push({
                        value: item.nOrder,
                        label: item.nOrder + "",
                        nID: item.nStrategyID
                    });

                    arr.lstChildren = [...arr.lstChildren, item]
                } else {
                    arr = dataRowProject.find(f => f.nStrategyID === item.nStrategyID);

                    if (arr) {
                        item.nOrder = 1;
                        arrOption.push({
                            value: item.nOrder,
                            label: item.nOrder + "",
                            nID: item.nStrategyID
                        });

                        arr.lstChildren = [item]
                        newData.push(arr);
                    }
                }
            })

            let arrData = []

            let option = [].concat(...newData.map(m => m.lstChildren));

            option.forEach(f => {
                f.sNoTopic = `${I18n.SetText("FundPlan.Project")}${I18n.SetText("FundPlan.No")} ${f.nOrder} `;
                let objOption = {
                    value: f.nID,
                    label: f.sName,
                    nOrder: f.nOrder,
                    sTopic: f.sTopic
                }

                arrData.push(objOption);
            })

            setDataRowProject([...newData]);

            setArrOptionOrderProject([...arrOption]);
            setArrOptionProject(arrData);
            setNEditProject(null);

            //set data activity
            let arrProject = [...option];
            lstActivty.forEach(activity => {
                activity.lstStrategy.forEach(strategy => {
                    let project = [...arrProject].filter(f => f.nStrategyID === strategy.nStrategyID);
                    strategy.lstProject = [...project];
                });
            });
            setDataRowActivity(lstActivty);
        })
    }

    const onUpdateData = (lstData, element, option, arrMonthDuration) => {
        //children
        let lstChildren = [...lstData].filter(f => f.nParentID === element.nID);
        let nCOrder = 1;

        lstChildren.forEach(f => {
            f.nOrder = nCOrder++;
            f.sOrder = element.sOrder + "." + f.nOrder;

            let arrOption = {
                label: f.sOrder + " " + f.sActivityName,
                value: f.nID,
                nProjectID: f.nProjectID,
                nParentID: f.nParentID,
                nLevel: f.nLevel
            }

            option.push(arrOption);

            onUpdateData(lstData, f, option, arrMonthDuration);
            arrMonthDuration.push(...element.lstMonth);
        })
    }

    const resetActivity = () => {
        setNEditActivity(null);
        setNEditActivityProject(null);

        //set data
        formActivity.setValue("isSubActivity", null);
        formActivity.setValue("sActivityName", null);
        formActivity.setValue("sBudget", null);
        formActivity.setValue("isBoardMeeting", null);
        formDuration.reset();
        formAssign.reset();
        formBoardMeeting.reset();
        setDataRowAssign([]);
        setArrDuration(defaultDuration);
        handleChangeSubActivity(false);
        handleChangeBoardMeeting(false);

        setNTriggerDuration(nTriggerDuration + 1);
        setNEditCommittee(null);
        setNEditAssign(null);
    }

    const onDeleteActivity = (nID, nProjectID) => {
        DialogFn.Submit("คุณการลบข้อมูลใช่หรือไม่?", () => {
            DialogFn.CloseSubmit();
            let lstData = [...dataRowActivity];
            let arrClone = lstData.filter(x => x.lstStrategy.some(c => c.lstProject.some(r => r.nID === nProjectID)));
            let option = [];

            arrClone.forEach(item => {
                [...item.lstStrategy].forEach(strategy => {
                    [...strategy.lstProject].forEach(project => {
                        if (project.nProjectID === nProjectID) {
                            let nOrder = 1;
                            let arrMonthDuration = [];

                            project.lstActivity = [...project.lstActivity].filter(f => f.nID !== nID && f.nParentID !== nID);

                            project.lstActivity.forEach(element => {

                                if (element.nParentID === null) {
                                    //parent
                                    element.nOrder = nOrder++;
                                    element.sOrder = element.nOrder + ".1";

                                    let arrOption = {
                                        label: element.sOrder + " " + element.sActivityName,
                                        value: element.nID,
                                        nProjectID: element.nProjectID,
                                        nParentID: element.nParentID,
                                        nLevel: element.nLevel,
                                        nMaxDate: element.nUnixTimeEnd,
                                        nMinDate: element.nUnixTimeStart,
                                        nBudget: parseFloat((element.sBudget).replace(/,/g, '')),
                                        nWeight: parseFloat((element.sWeight + "").replace(/,/g, ''))
                                    }

                                    option.push(arrOption);
                                    onUpdateData(project.lstActivity, element, option, arrMonthDuration);
                                    arrMonthDuration.push(...element.lstMonth);

                                } else if ([...project.lstActivity].filter(d => d.nID === element.nParentID).length <= 0) {
                                    project.lstActivity = [...project.lstActivity].filter(f => f.nID !== element.nID);

                                    arrMonthDuration.push(...[].concat(...project.lstActivity).map(m => m.lstMonth));
                                }
                            });

                            let nWeight = [...project.lstActivity].map(m => parseFloat(m.sSumWeight) || 0).reduce((a, b) => a + b, 0);
                            let nBudget = [...project.lstActivity].map(m => parseFloat(m.sBudget) || 0).reduce((a, b) => a + b, 0);
                            project.sWeight = formatNumber(nWeight, 2);
                            project.sBudget = formatNumber(nBudget, 2);

                            project.lstMonth = lstMonth;

                            project.lstMonth.forEach(f => {
                                if (!f.IsChecked) {
                                    let arr = [...arrMonthDuration].filter(m => m.nMonth === f.nMonth).map(m => m.IsChecked);
                                    f.IsChecked = Object.values(arr).includes(true);
                                }
                            });
                        }
                    })
                })
            });

            let lstID = arrClone.map(m => m.nStrategicID);
            let result = [...lstData].filter(f => !lstID.includes(f.nStrategicID));
            let activity = [...result, ...arrClone];
            activity = activity.slice().sort((a, b) => a.nOrder - b.nOrder);
            setDataRowActivity(activity);

            setDataOptionActivity([...dataOptionActivity.filter(f => f.nProjectID !== nProjectID), ...option]);

            if (nEditActivity === nID && nEditActivityProject === nProjectID) {
                resetActivity();
            }
        })
    }

    const handleChangeOrderGoal = (nNewOrder, nOldOrder) => {
        let arrClone = dataRowGoal;
        let arrRowClone = arrClone;
        let objSelf = arrRowClone.find((f) => f.nOrder === nOldOrder);

        //Order ใหม่มากกว่าเก่า
        if (nNewOrder > nOldOrder) {
            //เคสที่มากกว่าตัวเอง
            let arrChange = arrRowClone.filter(
                (f) => f.nOrder > nOldOrder && f.nOrder <= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder--;
            });
        } else {
            //Order ใหม่น้อยกว่าเก่า
            //เคสที่น้อยกว่าตัวเอง
            let arrChange = arrRowClone.filter(
                (f) => f.nOrder < nOldOrder && f.nOrder >= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder++;
            });
        }

        //อัพเดทตัวเอง
        objSelf.nOrder = nNewOrder;

        arrRowClone = arrRowClone.slice().sort((a, b) => a.nOrder - b.nOrder);

        arrClone = [...arrRowClone];
        setDataRowGoal([...arrClone]);
    };

    const handleChangeOrderStrategic = (nNewOrder, nOldOrder) => {
        let arrClone = dataRowStrategic;
        let arrRowClone = arrClone;
        let objSelf = arrRowClone.find((f) => f.nOrder === nOldOrder);

        //Order ใหม่มากกว่าเก่า
        if (nNewOrder > nOldOrder) {
            //เคสที่มากกว่าตัวเอง
            let arrChange = arrRowClone.filter(
                (f) => f.nOrder > nOldOrder && f.nOrder <= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder--;
            });
        } else {
            //Order ใหม่น้อยกว่าเก่า
            //เคสที่น้อยกว่าตัวเอง
            let arrChange = arrRowClone.filter(
                (f) => f.nOrder < nOldOrder && f.nOrder >= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder++;
            });
        }

        //อัพเดทตัวเอง
        objSelf.nOrder = nNewOrder;

        arrRowClone = arrRowClone.slice().sort((a, b) => a.nOrder - b.nOrder);

        arrClone = [...arrRowClone];
        setDataRowStrategic([...arrClone]);

        //order option Strategy
        let data = [...dataRowStrategy];
        let dtarget = [...dataRowTarget];
        let rowStrategy = [];
        let rowTarget = [];
        let optionStrategy = [];

        let arrData = [];
        arrClone.forEach(f => {
            let sNoTopic = `${I18n.SetText("FundPlan.Strategic")}${I18n.SetText("FundPlan.No")} ${f.nOrder} `;
            let objOption = {
                value: f.nID,
                label: sNoTopic + "" + f.sName,
                nOrder: f.nOrder,
                sTopic: "<b>" + sNoTopic + "</b>" + f.sName,
                sNoTopic: sNoTopic
            }

            arrData.push(objOption);

            let strategy = data.find(d => d.nID === f.nID);
            if (strategy) {
                strategy.nOrder = objOption.nOrder;
                strategy.sOrder = objOption.nOrder + "";
                strategy.sName = objOption.label;
                strategy.sTopic = objOption.sTopic;

                strategy.lstChildren.forEach(c => {
                    c.sOrder = strategy.nOrder + "." + c.nOrder;
                    c.sNoTopic = `${I18n.SetText("FundPlan.Strategy")}${I18n.SetText("FundPlan.No")} ${c.sOrder} `;
                    c.sTopic = "<b>" + c.sNoTopic + " </b>" + c.sName;

                    optionStrategy.push({ value: c.nOrder + "", label: c.sOrder, nID: c.nStrategicID });
                });
                rowStrategy.push(strategy);
            }

            let target = dtarget.find(d => d.nID === f.nID);
            if (target) {
                target.nOrder = objOption.nOrder;
                target.sName = objOption.label;
                target.sTopic = objOption.sTopic;
                target.sNoTopic = objOption.sNoTopic;
                rowTarget.push(target);
            }
        })

        setArrOptionStrategic(arrData);

        //data activity
        arrClone = arrClone.slice().sort((a, b) => a.nOrder - b.nOrder);
        setDataRowActivity([...arrClone]);

        //order option Strategy
        rowStrategy = rowStrategy.slice().sort((a, b) => a.nOrder - b.nOrder);
        setDataRowStrategy([...rowStrategy]);
        rowTarget = rowTarget.slice().sort((a, b) => a.nOrder - b.nOrder);
        setDataRowTarget([...rowTarget]);
        setArrOptionOrderStrategy([...optionStrategy]);
        let option = [].concat(...rowStrategy.map(m => m.lstChildren));
        let optionS = []

        option.forEach(f => {
            let objOption = {
                value: f.nID,
                label: f.sNoTopic + "" + f.sName,
                nOrder: f.nOrder,
                sTopic: f.sTopic
            }

            optionS.push(objOption);
        })

        setArrOptionStrategy(optionS);
    };

    const handleChangeOrderTarget = (nHeadID, nNewOrder, nOldOrder) => {
        let arrClone = dataRowTarget;
        let arrRowClone = [].concat(...arrClone.filter(f => f.nStrategicID === nHeadID).map(m => m.lstChildren));
        let objSelf = arrRowClone.find((f) => f.nOrder === nOldOrder);

        //Order ใหม่มากกว่าเก่า
        if (nNewOrder > nOldOrder) {
            //เคสที่มากกว่าตัวเอง
            let arrChange = arrRowClone.filter(
                (f) => f.nOrder > nOldOrder && f.nOrder <= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder--;
            });
        } else {
            //Order ใหม่น้อยกว่าเก่า
            //เคสที่น้อยกว่าตัวเอง
            let arrChange = arrRowClone.filter(
                (f) => f.nOrder < nOldOrder && f.nOrder >= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder++;
            });
        }

        //อัพเดทตัวเอง
        objSelf.nOrder = nNewOrder;

        arrRowClone = arrRowClone.slice().sort((a, b) => a.nOrder - b.nOrder);
        arrClone.find(f => f.nStrategicID === nHeadID).lstChildren = [...arrRowClone];
        setDataRowTarget([...arrClone]);
    };

    const handleChangeOrderStrategy = (nHeadID, nNewOrder, nOldOrder) => {
        let arrClone = dataRowStrategy;
        let arrRowClone = [].concat(...arrClone.filter(f => f.nStrategicID === nHeadID).map(m => m.lstChildren));
        let nHead = arrClone.find(f => f.nStrategicID === nHeadID)?.nOrder ?? 1;
        let objSelf = arrRowClone.find((f) => f.nOrder === nOldOrder);
        //Order ใหม่มากกว่าเก่า
        if (nNewOrder > nOldOrder) {
            //เคสที่มากกว่าตัวเอง
            let arrChange = arrRowClone.filter(
                (f) => f.nOrder > nOldOrder && f.nOrder <= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder--;
                f.sOrder = nHead + "." + f.nOrder;
                f.sNoTopic = `${I18n.SetText("FundPlan.Strategy")}${I18n.SetText("FundPlan.No")} ${f.sOrder} `;
                f.sTopic = "<b>" + f.sNoTopic + "</b>" + f.sName;
            });
        } else {
            //Order ใหม่น้อยกว่าเก่า
            //เคสที่น้อยกว่าตัวเอง
            let arrChange = arrRowClone.filter(
                (f) => f.nOrder < nOldOrder && f.nOrder >= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder++;
                f.sOrder = nHead + "." + f.nOrder;
                f.sNoTopic = `${I18n.SetText("FundPlan.Strategy")}${I18n.SetText("FundPlan.No")} ${f.sOrder} `;
                f.sTopic = "<b>" + f.sNoTopic + "</b>" + f.sName;
            });
        }

        //อัพเดทตัวเอง
        objSelf.nOrder = nNewOrder;
        objSelf.sOrder = nHead + "." + nNewOrder;

        arrRowClone = arrRowClone.slice().sort((a, b) => a.nOrder - b.nOrder);
        arrClone.find(f => f.nStrategicID === nHeadID).lstChildren = [...arrRowClone];
        setDataRowStrategy([...arrClone]);

        //order activity
        let data = [...dataRowActivity];
        data = data.slice().sort((a, b) => a.nOrder - b.nOrder);

        data.forEach(d => {
            d.lstStrategy = [...d.lstStrategy.slice().sort((a, b) => a.nOrder - b.nOrder)];
        });

        setDataRowActivity([...data]);

        let option = [].concat(...arrClone.map(m => m.lstChildren));
        let optionS = []

        option.forEach(f => {
            let objOption = {
                value: f.nID,
                label: f.sNoTopic + "" + f.sName,
                nOrder: f.nOrder,
                sTopic: f.sTopic
            }

            optionS.push(objOption);
        })

        setArrOptionStrategy(optionS);
    };

    const handleChangeOrderProject = (nHeadID, nNewOrder, nOldOrder) => {
        let arrClone = [...dataRowProject];
        let arrRowClone = [].concat(...arrClone.filter(f => f.nStrategyID === nHeadID).map(m => m.lstChildren));
        let objSelf = arrRowClone.find((f) => parseFloat(f.nOrder) === nOldOrder);

        //Order ใหม่มากกว่าเก่า
        if (nNewOrder > nOldOrder) {
            //เคสที่มากกว่าตัวเอง
            let arrChange = arrRowClone.filter(
                (f) => f.nOrder > nOldOrder && f.nOrder <= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder--;
            });
        } else {
            //Order ใหม่น้อยกว่าเก่า
            //เคสที่น้อยกว่าตัวเอง
            let arrChange = arrRowClone.filter(
                (f) => f.nOrder < nOldOrder && f.nOrder >= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder++;
            });
        }

        //อัพเดทตัวเอง
        objSelf.nOrder = nNewOrder;

        arrRowClone = arrRowClone.slice().sort((a, b) => a.nOrder - b.nOrder);
        arrClone.find(f => f.nStrategyID === nHeadID).lstChildren = [...arrRowClone];
        setDataRowProject([...arrClone]);

        //order activity
        let data = [...dataRowActivity];
        data = data.slice().sort((a, b) => a.nOrder - b.nOrder);

        data.forEach(d => {
            d.lstStrategy = [...d.lstStrategy.slice().sort((a, b) => a.nOrder - b.nOrder)];
            d.lstStrategy.forEach(s => {
                s.lstProject = [...s.lstProject.slice().sort((a, b) => a.nOrder - b.nOrder)];
            })
        });

        setDataRowActivity([...data]);
    };

    const handleChangeFiscalYear = (nYear, sFundWorkID) => {
        if (nYear?.isValid()) {
            setNYear(nYear.year());
            AxiosFn.Get(`FundActionPlan/GetInitialProject`, { nYear: nYear.year() }, (result) => {
                if (result.objResult) {
                    let data = result.objResult;
                    setArrOptionIndicator(DefaultArrayEmpty(data.lstIndicator));
                    if (data.IsHasPlan && sFundWorkID === null) {
                        DialogFn.Warning("พบข้อมูลแผนปฎิบัติการกองทุนฯ ประจำปี " + (nYear.year() + 543) + " ซ้ำในระบบ", () => {
                            setArrOptionIndicator([]);
                            setNYear(null);
                            form.setValue("sFiscalYear", null);
                        });
                    }
                }
            })
        } else {
            setArrOptionIndicator([]);
            setNYear(null);
        }
    }

    const onSetDataForm = (data) => {

        setObjDataForm(data);
        setisSubmitted(data.isSubmit);

        setNFundWorkID(data.nFundWorkID);

        let dDate = moment(data.nYear + "/01/01");
        if (!dDate.isValid()) {
            dDate = moment();
        }
        handleChangeFiscalYear(dDate, data.nFundWorkID);
        form.setValue("sFiscalYear", dDate);
        form.setValue("sVision", data.sVision);
        form.setValue("sMission", data.sMission);
        setNYear(dDate.year());

        let lstGoal = [...data.lstGoal];
        setDataRowGoal(lstGoal);
        setArrOptionOrderGoal(lstGoal.map(m => ({ value: m.nOrder + "", label: m.nOrder })));

        let lstStrategic = [...data.lstStrategic];
        setDataRowActivity(lstStrategic);
        setDataRowStrategic(lstStrategic);
        setArrOptionOrderStrategic(lstStrategic.map(m => ({ value: m.nOrder + "", label: m.nOrder })));
        setArrOptionStrategic(lstStrategic.map(m => ({
            value: m.nID,
            label: m.sNoTopic + " " + m.sName,
            nOrder: m.nOrder,
            sTopic: m.sTopic,
            sNoTopic: m.sNoTopic + " "
        })))

        let dataTarget = [];
        let orderTarget = [];
        let dataStrategy = [];
        let lstDatatrategy = [];
        let orderStrategy = [];
        lstStrategic.forEach(item => {

            if ([...item.lstTarget].length > 0) {
                let objHead = {
                    nID: item.nStrategicID,
                    sID: item.nStrategicID + "",
                    nOrder: item.nOrder,
                    nStrategicID: item.nStrategicID,
                    sName: item.sNoTopic + " " + item.sName,
                    sTopic: item.sTopic,
                    sNoTopic: item.sNoTopic,
                    IsHead: true,
                    lstChildren: []
                }

                let lstTarget = [...item.lstTarget];
                let objTarget = { ...objHead };
                objTarget.lstChildren = lstTarget;
                orderTarget = [...orderTarget, ...lstTarget.map(m => ({ value: m.nOrder + "", label: m.nOrder, nID: item.nStrategicID }))];
                dataTarget.push(objTarget);

                let lstStrategy = [...item.lstStrategy];
                let objStrategy = { ...objHead };
                lstDatatrategy = [...lstDatatrategy, ...lstStrategy];
                objStrategy.lstChildren = lstStrategy;
                orderStrategy = [...orderStrategy, ...lstStrategy.map(m => ({ value: m.nOrder + "", label: m.sOrder, nID: item.nStrategicID }))];
                dataStrategy.push(objStrategy);
            }
        });

        setDataRowTarget([...dataTarget]);
        setArrOptionOrderTarget([...orderTarget]);
        setDataRowStrategy([...dataStrategy]);
        setArrOptionOrderStrategy([...orderStrategy]);
        setArrOptionStrategy(lstDatatrategy.map(m => ({
            value: m.nID,
            label: m.sNoTopic + " " + m.sName,
            nOrder: m.nOrder,
            sTopic: m.sTopic + " "
        })));

        let lstProject = [];
        lstDatatrategy.forEach(item => {

            if ([...item.lstProject].length > 0) {
                let obj = {
                    nID: item.nStrategyID,
                    sID: item.nStrategyID + "",
                    nOrder: item.nOrder,
                    nStrategyID: item.nStrategyID,
                    sName: item.sNoTopic + " " + item.sName,
                    sTopic: item.sTopic,
                    IsHead: true,
                    lstChildren: item.lstProject
                }

                lstProject.push(obj);
            }
        });
        let lstDataProject = [].concat(...lstDatatrategy.map(m => m.lstProject));
        setDataRowProject(lstProject);
        let arrOrderProject = [];
        let arrOptionProject = [];

        lstDataProject.forEach(m => {
            let order = {
                value: m.nOrder + "",
                label: m.nOrder,
                nID: m.nStrategyID
            }

            let project = {
                value: m.nID,
                label: m.sName,
                nOrder: m.nOrder,
                sTopic: m.sTopic
            }

            arrOrderProject.push(order);
            arrOptionProject.push(project);
        })
        setArrOptionOrderProject(arrOrderProject);
        setArrOptionProject(arrOptionProject);

        let lstActivity = [].concat(...lstDataProject.map(m => m.lstActivity));
        setDataOptionActivity(lstActivity.map(m => ({
            label: m.sOrder + " " + m.sActivityName,
            value: m.nID,
            nProjectID: m.nProjectID,
            nParentID: m.nParentID,
            nLevel: m.nLevel,
            nMaxDate: m.nUnixTimeEnd,
            nMinDate: m.nUnixTimeStart,
            nBudget: parseFloat((m.sBudget + "").replace(/,/g, '')),
            nWeight: parseFloat((m.sWeight + "").replace(/,/g, ''))
        })));

        //set file
        setArrFileMOU([...data.lstFileMOU]);
        setArrFilePlan([...data.lstFilePlan]);
    }

    const onGetDataFundPlan = (sID) => {
        DialogFn.BlockUI();
        AxiosFn.Get(`FundActionPlan/GetDataFundActionPlan`, { sID: sID }, (result) => {
            DialogFn.UnBlockUI();
            if (result.objResult) {
                onSetDataForm(result.objResult)

            }
        })
    }

    const onGetCommittee = () => {
        AxiosFn.Get(`FundActionPlan/GetCommittee`, {}, (result) => {
            if (result.objResult) {
                let data = result.objResult;
                setArrOptionCommittee(DefaultArrayEmpty(data.lstCommittee));
            }
        })
    }

    const handleChangeActivity = (event) => {
        let clone = [...dataOptionActivity];

        if (event && arrActivity.length < 4) {
            let any = clone.filter(f => f.nParentID === event.value);
            if (any.length > 0) {
                if (arrActivity.length <= event.nLevel) {
                    let nMax = arrActivity.length > 0 ? Math.max(...arrActivity.map(o => o.nID)) + 1 : 1;

                    let obj = {
                        nID: nMax,
                        sID: nMax + ""
                    }
                    setArrActivity([...arrActivity, obj]);
                }
            }

            let nRemove = event.nLevel - arrActivity.length;
            if (nRemove < 0) {
                setArrActivity([...arrActivity.slice(0, nRemove)]);
            }

            setNMaxMonth(event.nMaxDate);
            setNMinMonth(event.nMinDate);

            let nAllBudget = any.map(m => m.nBudget).reduce((a, b) => a + b, 0);

            setNMaxBudget(event.nBudget - nAllBudget);
            setNMaxWeight(event.nWeight);
            setNParentID(event.value);
        }
    }

    const handleDraft = () => {
        let formData = form.getValues();

        let sFiscalYear = moment(formData.sFiscalYear);

        let nYear = sFiscalYear.isValid() ? sFiscalYear.year() : null;

        if (!nYear) {
            DialogFn.Warning("กรุณาใส่ข้อมูลประจำปีบัญชี");
            document.getElementById("sFiscalYear")?.focus();
        } else {
            let obj = {
                sMode: "D",
                isDuplicate: isDuplicate,
                nFundWorkID: nFundWorkID,
                nYear: nYear,
                sVision: formData.sVision,
                sMission: formData.sMission,
                lstGoal: dataRowGoal,
                lstStrategic: dataRowActivity,
                lstFileMOU: arrFileMOU,
                lstFilePlan: arrFilePlan
            }

            DialogFn.Submit("คุณต้องการบันทึกร่าง ใช่หรือไม่", () => {
                DialogFn.BlockUI();
                AxiosFn.Post(`FundActionPlan/SaveFundActionPlan`, obj, (result) => {
                    DialogFn.UnBlockUI();
                    if (result.sMessage) {
                        DialogFn.Warning(result.sMessage);
                    } else {
                        DialogFn.Success(`บันทึกร่างสำเร็จ`);
                        DialogFn.CloseSubmit()
                        Router.GoToPage("/FundActionPlan");
                    }
                }, (err) => {
                    DialogFn.UnBlockUI();
                    if (!err.response) {
                        DialogFn.Warning(err.sMessage);
                    }
                });
            })
        }
    }

    const handleSubmitPlan = () => {
        let isEmptyActivity = dataRowActivity.length < 1;
        let isEmptyProject = dataRowProject.length < 1;
        let isEmptyStrategy = dataRowStrategy.length < 1;
        let isEmptyStrategic = dataRowStrategic.length < 1;
        let isEmptyTarget = dataRowTarget.length < 1;
        let isEmptyGoal = dataRowGoal.length < 1;

        if (isEmptyActivity || isEmptyProject || isEmptyStrategy || isEmptyStrategic || isEmptyTarget || isEmptyGoal) {
            let sMsg = "กรุณากรอกข้อมูลดังต่อไปนี้ให้ครบถ้วน";

            if (isEmptyGoal) {
                sMsg += "<br/>- เป้าประสงค์";
            }
            if (isEmptyStrategic) {
                sMsg += "<br/>- ยุทธศาสตร์";
            }
            if (isEmptyTarget) {
                sMsg += "<br/>- เป้าประสงค์เชิงยุทธศาสตร์";
            }
            if (isEmptyStrategy) {
                sMsg += "<br/>- กลยุทธ์";
            }
            if (isEmptyProject) {
                sMsg += "<br/>- โครงการ";
            }
            if (isEmptyActivity) {
                sMsg += "<br/>- กิจกรรม";
            }

            DialogFn.Warning(sMsg);
            setIsDuplicate(false);
        } else {
            let formData = form.getValues();

            let sFiscalYear = moment(formData.sFiscalYear);

            let nYear = sFiscalYear.isValid() ? sFiscalYear.year() : null;

            let obj = {
                sMode: "S",
                isDuplicate: isDuplicate,
                nFundWorkID: nFundWorkID,
                nYear: nYear,
                sVision: formData.sVision,
                sMission: formData.sMission,
                lstGoal: dataRowGoal,
                lstStrategic: dataRowActivity,
                lstFileMOU: arrFileMOU,
                lstFilePlan: arrFilePlan
            }

            let clone = [...dataRowActivity];
            //// let asrrClone = clone.filter(x => x.lstStrategy.some(c => c.lstProject.some(r => parseFloat(r.sWeight) < 100)));
            //// let arrClone = [].concat(...clone.map(m => m.lstStrategy));

            // Extracting
            let merged = [].concat(...clone.map(item => item.lstStrategy.map(project => project.lstProject)).flat());

            let IsWeightNot = false;
            let IsBudgetNot = false;
            let IsAssignNot = false;

            merged.forEach(project => {
                let data = project.lstActivity;

                // Flatten the data and extract IDs and parentIDs
                let allIDs = data.flatMap(item => item.nActivityID);
                let parentIDs = data.filter(f => f.nParentID !== null).flatMap(item => item.nParentID);
                // Filter out IDs which are not parentID of another
                let nonParentIDs = allIDs.filter(id => !parentIDs.includes(id));

                //case: no has sub activity
                if ([...parentIDs].length === 0) {
                    nonParentIDs = allIDs
                }

                let nWeightMaster = 100;
                let nWeightAll = data.filter(w => nonParentIDs.includes(w.nActivityID)).map(m => parseFloat(m.sWeight.replace(/,/g, ''))).reduce((a, b) => a + b, 0);
                let nBudgetAll = data.filter(w => nonParentIDs.includes(w.nActivityID)).map(m => parseFloat(m.sBudget.replace(/,/g, ''))).reduce((a, b) => a + b, 0);

                let lstAssign = data.filter(w => nonParentIDs.includes(w.nActivityID) && [...w.lstAssign].length === 0).map(m => m.nActivityID);

                if (nWeightAll !== nWeightMaster) {
                    IsWeightNot = true;
                    IsBudgetNot = nBudgetAll !== parseFloat((project.sBudget).replace(/,/g, ''));
                    IsAssignNot = [...lstAssign].length > 0
                    return;
                }

                if (nBudgetAll !== parseFloat((project.sBudget).replace(/,/g, ''))) {
                    IsBudgetNot = true;
                    IsAssignNot = [...lstAssign].length > 0
                    return;
                }

                if ([...lstAssign].length > 0) {
                    IsAssignNot = true;
                    return;
                }

            });

            if (IsAssignNot) {
                DialogFn.Warning("กรุณาใส่ข้อมูลผู้รับผิดชอบให้ครบถ้วน");
                setIsDuplicate(false);
                return;
            }

            if (IsWeightNot && IsBudgetNot) {

                DialogFn.Warning("รายละเอียดค่าน้ำหนัก และงบประมาณไม่ครบถ้วน");
                setIsDuplicate(false);
                return;

            } else if (IsWeightNot) {
                DialogFn.Warning("รายละเอียดค่าน้ำหนักไม่ครบถ้วน");
                setIsDuplicate(false);
                return;
            } else if (IsBudgetNot) {
                DialogFn.Warning("รายละเอียดงบประมาณไม่ครบถ้วน");
                setIsDuplicate(false);
                return;
            }

            DialogFn.Submit("คุณต้องการบันทึก ใช่หรือไม่", () => {
                DialogFn.BlockUI();
                AxiosFn.Post(`FundActionPlan/SaveFundActionPlan`, obj, (result) => {
                    DialogFn.UnBlockUI();
                    if (result.sMessage) {
                        DialogFn.Warning(result.sMessage);
                    } else {
                        DialogFn.Success(`บันทึกสำเร็จ`);
                        DialogFn.CloseSubmit()
                        Router.GoToPage("/FundActionPlan");
                    }

                }, (err) => {
                    DialogFn.UnBlockUI();
                    if (!err.response) {
                        DialogFn.Warning(err.sMessage);
                    }
                });
            });
        }
    }


    return {
        DialogFn,
        form,
        formProject,
        formGoal,
        formBoardMeeting,
        formBoardMeetingTable,
        formTarget,
        formStrategic,
        formDuration,
        formStrategy,
        formActivity,
        formAssign,
        dataRowGoal,
        dataRowTarget,
        dataRowStrategic,
        dataRowStrategy,
        dataRowProject,
        dataRowAssign,
        dataRowCommittee,
        dataRowActivity,
        loadingTable,
        onGetCommittee,
        onDeleteGoal,
        onDeleteStrategic,
        onDeleteTarget,
        onDeleteStrategy,
        onDeleteProject,
        onAddDuration,
        onDeleteDuration,
        onAddBoardMeeting,
        onDeleteBoardMeeting,
        onDeleteAssign,
        onDeleteCommittee,
        onDeleteActivity,
        onAddGoal,
        handleChangeOrderGoal,
        handleChangeOrderStrategic,
        handleChangeOrderTarget,
        handleSubmitStrategic,
        handleSubmitTarget,
        handleSubmitStrategy,
        handleSubmitProject,
        handleSubmitAssign,
        handleChangeOrderStrategy,
        handleChangeOrderProject,
        handleChangeFiscalYear,
        handleChangeSubActivity,
        handleChangeBoardMeeting,
        handleSubmitCommittee,
        handleSubmitActivity,
        handleChangeActivity,
        handleChangeProject,
        handleSubmitPlan,
        handleEditGoal,
        handleEditStrategic,
        handleEditTarget,
        handleEditStrategy,
        handleEditProject,
        nEditProject,
        nEditStrategy,
        nEditTarget,
        nEditGoal,
        nEditStrategic,
        nProjectCurrent,
        isSubActivity,
        isBoardMeeting,
        arrOptionIndicator,
        arrOptionOrderGoal,
        arrOptionOrderStrategic,
        arrOptionOrderTarget,
        arrOptionOrderStrategy,
        arrDuration,
        arrBoardMeeting,
        arrOptionStrategic,
        arrOptionTarget,
        arrOptionStrategy,
        arrOptionOrderProject,
        arrOptionProject,
        dataOptionActivity,
        nYear,
        arrOptionCommittee,
        trigger,
        nTriggerDuration,
        arrActivity,
        arrFileMOU,
        setArrFileMOU,
        arrFilePlan,
        setArrFilePlan,
        handleClearAttachFileMOU,
        handleClearAttachFilePlan,
        handleDraft,
        handleEditActivity,
        onGetDataFundPlan,
        nEditActivity,
        nEditActivityProject,
        onDuplicateForm,
        isSubmitted,
        handleEditCommittee,
        nEditCommittee,
        handleEditAssign,
        nEditAssign,
        nMaxMonth,
        nMinMonth,
        setNMaxMonthDueDate,
        setNMinMonthDueDate,
        nMinMonthDueDate,
        nMaxMonthDueDate,
        nMaxBudget,
        nMaxWeight,
        nParentID,
        isPermission
    };
}

export function useCalendarEvent() {

    const AxiosFn = FnAxios();
    const [arrEvent, setArrEvent] = useState([]);
    const [arrActivity, setArrActivity] = useState([]);
    const [nCurrent, setNCurrent] = useState(null);

    useEffect(() => {
        GetCalendarEvent();
    }, [nCurrent]);

    const GetCalendarEvent = () => {
        AxiosFn.Get(`FundActionPlan/GetCalendarEvent`, { nCurrentDate: nCurrent }, (result) => {
            let data = result.objResult;
            if (data) {
                setArrEvent([...DefaultArrayEmpty(data.lstMeeting)]);
                setArrActivity([...DefaultArrayEmpty(data.lstActivity)]);
            }

        });
    }

    const onCalenderChange = (event) => {
        let d = moment(event.view.currentStart);
        if (!d.isValid()) {
            d = moment();
        }
        setNCurrent(ConvertDateToUnixOrNull(d.startOf('month')));
    }

    return { arrEvent, arrActivity, onCalenderChange };
}